import tmObs from "../lib/tmObs.js";
import Util from "../lib/util.js";
import Logger from "./../lib/logger";
import geodesic from "./../lib/geodesic.js";
import tmList from "../lib/tmList.js";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
import { makeCancellable, takeLatest } from "vuex-cancellable-actions";

/** Repository */
const TelemeterRepository = RepositoryFactory.get("telemeter");
const TelemeterGeojsonRepository = RepositoryFactory.get("telemeterGeojson");
const IuRepository = RepositoryFactory.get("iu");
const TelemeterJsonRepository = RepositoryFactory.get("telemeterJson");
const TelemeterObsJsonRepository = RepositoryFactory.get("telemeterObsJson");
const SwinJsonRepository = RepositoryFactory.get("swin");
const SystemJsonRepository = RepositoryFactory.get("systemJson");
const MapJsonRepository = RepositoryFactory.get("mapJsonRepository");

const stateReadyMovie = "readyMovie"
const statePlay = "play";
const stateStop = "stop";
const stateNone = "none";

export default {
  namespaced: true,
  state: {
    /** 横断設定 */
    crossConfig: {},
    /** グラフ設定 */
    graphConfig: {},
    /** メッセージ設定 */
    messageConfig: {},
    /** 個別観測所設定 */
    tmObsConfig: {},
    /** 表示範囲の水位GeoJson */
    stgGeoJsons: [],
    /** 表示範囲のダムGeoJson */
    damGeoJsons: [],
    /** 表示範囲のカメラGeoJson */
    scamGeoJsons: [],
    /** 表示範囲の雨量GeoJson */
    rnGeoJsons: [],
    /** 表示範囲の水質GeoJson */
    qwtrGeoJsons: [],
    /** 表示範囲の海岸GeoJson */
    coastGeoJsons: [],
    /** 表示範囲の積雪GeoJson */
    snwGeoJsons: [],
    /** 表示範囲の危機管理型水位GeoJson */
    swstgGeoJsons: [],
    /** 予警報の基準観測所GeoJson */
    baseobsGeoJsons: null,
    /** GeoJson取得状態 */
    geoJsonGetStatus: {
      stg: false,
      dam: false,
      rn: false,
      qwtr: false,
      coast: false,
      snw: false,
      scam: false,
      swstg: false,
    },
    /** GeoJSON取得状態更新時刻 */
    geoJsonGetStatusTime: null,
    /** 表示範囲のテレメータ情報パラメータ */
    tmDatasParam: {
      /** 表示時刻 */
      dispTime: null,
      /** 都道府県別市町村リスト取得時刻 */
      townsAcqTime: null,
      /** 水系別市町村リスト取得時刻 */
      rsysAcqTime: null,
    },
    /** 表示範囲のテレメータ超過情報 */
    tmOverDatas: [],
    /** 表示範囲のテレメータ超過情報パラメータ */
    tmOverDatasParam: {
      /** 表示時刻 */
      dispTime: null,
      /** 市町村リスト取得時刻 */
      townsAcqTime: null,
    },
    /** 選択中テレメータ情報 */
    selectedTm: [],
    /** 選択中テレメータ情報パラメータ */
    selectedTmParam: {
      /** 管理事務所番号 */
      ofcCd: null,
      /** 観測所種別コード */
      itmkndCd: null,
      /** 選択中観測所番号 */
      obsCd: null,
      /** 選択中河川カメラID */
      cctvCd: null,
      /** 選択中危機管理型河川カメラID */
      swcctvCd: null,
      /** 選択中簡易カメラID */
      scamId: null,
      /** システムカメラID */
      sysCamId: null,
      /** 所有ユーザID */
      ownCd: null,
    },
    /** 選択中テレメータ過去観測値情報 */
    selectedTmPast: null,
    /**  */
    tmStgAdditionalInfo: {},
    /** 横断設定情報 */
    surfaceConf: {},
    /** 横断データ */
    surface: {},
    /** 地点登録テレメータ情報 */
    tmPointDatas: {},
    /** 地点登録 選択テレメータ情報  */
    tmSelectedPointData: {},
    /** 地点登録 選択テレメータ対象日時情報  */
    tmPointIndivDatas: {},
    /** 地点登録 選択テレメータ対象日時情報パラメータ  */
    tmPointIndivDatasParam: {
      /** 登録地点観測所一覧リスト取得時刻 */
      dispTime: null,
    },
    /** 地点登録状況 */
    registPointState: 0,
    /** 地点登録エラーメッセージ */
    registPointErrMsg: "",
    /** 地点登録メッセージ */
    registPointMsg: "",
    /** 地点登録パラメータ */
    registPointParam: {},
    /** 観測所一覧表示モード(0:市町村別、1:水系別、2:基準値超過) */
    obsListMode: null,
    /** 観測所表示設定 */
    selectObsDisp: [
      {
        /** 通常水位表示 */
        stgDisp: true,
        /** 危機管理型水位表示 */
        swstgDisp: true,
        /** 河川カメラ表示 */
        cctvDisp: true,
        /** ダム諸量表示 */
        damDisp: true,
        /** 雨量表示 */
        rnDisp: false,
        /** 海岸表示 */
        coastDisp: false,
        /** 積雪深表示 */
        snwDisp: false,
        /** 水質表示 */
        qwtrDisp: false,
      },
    ],
    /** 拡縮表示設定(false:全体、true:拡大) */
    scalMode: null,
    /** [水位観測/水位計個別観測所]横断図拡縮表示設定(false:全体、true:拡大) */
    scalModeXSec: null,
    /** [水位観測/水位計個別観測所]グラフ拡縮表示設定(false:全体、true:拡大) */
    scalModeGraph: null,
    /** 表示時刻設定(false:10分単位、true:時間単位) */
    timeMode: null,
    /** 凡例表示状態(false:非表示、true:表示) */
    isLegendDisp: null,
    /** 選択中河川カメラ画像("live":最新、"normal":平常時) */
    selectCamera: null,
    /** 最新観測値切替 */
    latestObsIdx: null,
    /** コンテンツ切替 */
    obsDispStatus: {
      /** 河川予警報情報一覧 */
      riverWarnInfo: null,
      /** お知らせ情報一覧 */
      info: null,
      /** 観測所グラフ */
      obsGraph: null,
      /** 観測値一覧 */
      valuesList: null,
      /** グラフ切替 */
      graphSwitch: {
        /** 雨量グラフ */
        rainGraph: null,
        /** 風向・風速グラフ */
        windGraph: null,
        /** 潮位グラフ */
        tideGraph: null,
        /** 最大波グラフ */
        maxWaveGraph: null,
        /** 1/3有義波グラフ */
        onthWaveGraph: null,
        /** 水質グラフ左軸 */
        leftAxisGraph: null,
        /** 水質グラフ右軸 */
        rightAxisGraph: null,
      },
      /** 河川カメラ */
      cctv: null,
      /** 模式図 */
      diag: null,
      /** 断面図 */
      xsec: null,
      /** 簡易カメラ */
      scam: null,
    },
    /** 履歴動画準備状態('ready':準備状態, 'playable':再生可状態) */
    historyPlayPrepStatus: "ready",
    /** 観測所一覧タブ設定 */
    tmListTabIndex: 0,
    /** 観測所一覧市町村別全開閉フラグ */
    tmListTwnFullOpenFlg: false,
    /** 観測所一覧市町村別全開閉準備フラグ */
    tmListTwnFullOpenReadyFlg: false,
    /** 観測所一覧市町村別全開閉完了フラグ */
    tmListTwnFullOpenEndFlg: false,
    /** 観測所一覧水系別全開閉フラグ */
    tmlistRsysFullOpenFlg: false,
    /** 観測所一覧水系別全開閉準備フラグ */
    tmListRsysFullOpenReadyFlg: false,
    /** 観測所一覧水系別全開閉完了フラグ */
    tmListRsysFullOpenEndFlg: false,
    /** 都道府県市町村別観測所一覧情報 */
    prefTmList: {},
    /** 表示都道府県市町村別観測所一覧情報 */
    dispPrefTmList: {},
    /** 水系河川別観測所一覧情報 */
    rsysTmList: {},
    /** 表示水系河川別観測所一覧情報 */
    dispRsysTmList: {},
    /** [MB]個別観測所画面が拡大されている */
    mbTmObsIsExpansion: false,
    /** 基準値超過テレメータ存在フラグ */
    tmOverExistenceFlg: false,
    /** [MB]基準値超過タブフラグ */
    tmOverListFlg: 0,
    /** 登録APIのメッセージ */
    apiMessage: "",
    /** 最新値ファイル用欠測判定時間 */
    missingTime: 0,
    /** 横断図SVGエラー */
    crossSvgError: false,
    /** 基準値超過テレメータ種別存在フラグ */
    typeFlg: {
      tmStgFlg: false,
      tmRnFlg: false,
      swStgFlg: false,
    },
    /** アクセスログ出力用パラメータ */
    pageLogParam: null,
    /** 地図アイコンからの遷移フラグ */
    mapIconFlg: false,
    /** 過去画像表示関連 */
    historyPrintCurrentPicture: "",
    latestScamTime: null,
    /** スライダー関連 */
    historyImageSlider: {
      // 取得した画像配列
      arrayHistoryImages: [],
      // 取得した画像と同じ時間の配列(appTime用)
      arrayHistoryAppTime: [],
      // 取得した画像と同じ時間の配列(スライダーラベル用)
      sliderLabelTime: [],
      // 取得した画像の詳細時間の配列(latestTime用)
      detailTime: [],
      // 通常画面現在位置（currentIndex）
      movieCurrentIndex: 0,
      // 拡大画面現在位置（currentIndex）
      enlargedMovieCurrentIndex: 0,
      // スライド終了時刻
      movieEndTime: 0,
      // 通常画面用スライダーの状態 ['none':無再生状態, 'movieRadar':過去画像準備状態, 'play':再生状態, 'stop':停止状態]
      historyPlayStatus: stateNone,
      // 拡大画面用スライダーの状態 ['none':無再生状態, 'movieRadar':過去画像準備状態, 'play':再生状態, 'stop':停止状態]
      enlargeHistoryPlayStatus: stateNone,
      // 過去画像再生ボタン押下フラグ
      historyImageMovieFlg: false,
      // スライダー再生時appTime制御（appTime変更時ロード走らせないため）
      appTimeControlFlg: false,
      // 画像拡大画面フラグ
      expandedScreeModal: false,
      // スライダー過去画像不足フラグ
      sliderMissingImages: false,
      // PCスライダー用表示画面 ['normal': 通常画面, 'enlarged':拡大画面]
      viewMode: "normal",
      // MBスライダー用拡大画面フラグ
      isEnlargeView: false
    }
  },
  mutations: {
    /**
     * 横断設定
     * @param {*} state
     * @param {*} crossConfig
     */
    setCrossConfig(state, crossConfig) {
      state.crossConfig = crossConfig;
    },
    /**
     * グラフ設定
     * @param {*} state
     * @param {*} graphConfig
     */
    setGraphConfig(state, graphConfig) {
      state.graphConfig = graphConfig;
    },
    /**
     * メッセージ設定
     * @param {*} state
     * @param {*} messageConfig
     */
    setMessageConfig(state, messageConfig) {
      state.messageConfig = messageConfig;
    },
    /**
     * 個別観測設定
     * @param {*} state
     * @param {*} tmObsConfig
     */
    setTmObsConfig(state, tmObsConfig) {
      state.tmObsConfig = tmObsConfig;
    },
    /**
     * 対象日時を設定
     * @param {*} state
     * @param appTime 対象日時
     */
    setAppTimeParam(state, appTime) {
      state.tmOverDatasParam.dispTime = appTime;
    },
    /**
     * API実行時のパラメータを設定
     * @param {*} state
     * @param appTime 対象日時
     * @param townsAcqTime 都道府県別市町村リスト取得日時
     * @param rsysAcqTime 水系別市町村リスト取得日時
     */
    setTmDatasParam(state, { appTime, townsAcqTime, rsysAcqTime }) {
      Logger.debug(
        "[Telemeter]mut  - setTmDatasParam(state," +
          appTime +
          "," +
          townsAcqTime +
          "," +
          rsysAcqTime +
          ")"
      );
      state.tmDatasParam.dispTime = appTime;
      state.tmDatasParam.townsAcqTime = townsAcqTime;
      state.tmDatasParam.rsysAcqTime = rsysAcqTime;
    },
    /**
     * API実行時のパラメータを設定
     * @param {*} state
     * @param appTime 対象日時
     * @param townsAcqTime 市町村リスト取得日時
     */
    setTmOverDatasParam(state, { appTime, townsAcqTime }) {
      Logger.debug(
        "[Telemeter]mut  - setTmOverDatasParam(state," +
          appTime +
          "," +
          townsAcqTime +
          ")"
      );
      state.tmOverDatasParam.dispTime = appTime;
      state.tmOverDatasParam.townsAcqTime = townsAcqTime;
    },
    /**
     * APIから取得したテレメータ基準値超過情報を展開
     * @param {*} state
     * @param {*} data
     */
    setTmOverDatas(state, data) {
      Logger.debug("[Telemeter]mut - setTmOverDatas()");
      Logger.dir(data);
      state.tmOverDatas = data;
    },
    /**
     * 観測所選択
     * @param {*} state
     * @param {*} ofcCd 管理事務所番号
     * @param {*} itmkndCd 観測所種別コード
     * @param {*} obsCd 観測所コード
     */
    setSelectedTm(state, selectedTm) {
      Logger.debug("[Telemeter]mut - setSelectedTm(selectedTm)");
      Logger.dir(selectedTm);
      state.selectedTm = selectedTm;
    },
    /**
     * 選択中テレメータ情報パラメータ
     * @param {*} state
     * @param {*} selectedTm 選択中のテレメータ情報
     */
    setSelectedTmParam(state, selectedTm) {
      Logger.debug(
        "[Telemeter]mut - setSelectedTmParam(" +
          selectedTm.ofcCd +
          "," +
          selectedTm.itmkndCd +
          "," +
          selectedTm.obsCd +
          ")"
      );
      state.selectedTmParam = selectedTm;
    },
    /**
     * 選択中テレメータ情報パラメータ TODO:廃止予定
     * @param {*} state
     * @param {*} selectedTm 選択中のテレメータ情報
     */
    setSelectedTmParamCctv(state, selectedTm) {
      Logger.debug(
        "[Telemeter]mut - setSelectedTmParamCctv(" +
          selectedTm.ofcCd +
          "," +
          selectedTm.itmkndCd +
          "," +
          selectedTm.cctvCd +
          "," +
          selectedTm.scamId +
          ")"
      );
      state.selectedTmParam = selectedTm;
    },
    /**
     * 選択中テレメータ情報パラメータ
     * @param {*} state
     * @param {*} selectedTm 選択中のテレメータ情報
     */
    setSelectedTmParamScam(state, selectedTm) {
      Logger.debug(
        "[Telemeter]mut - setSelectedTmParamScam(" +
          selectedTm.itmkndCd +
          "," +
          selectedTm.scamId +
          "," +
          selectedTm.ownCd +
          "," +
          selectedTm.sysCamId +
          ")"
      );
      state.selectedTmParam = selectedTm;
    },
    /**
     * 選択中テレメータ観測値過去情報
     * @param {*} state
     * @param {*} pastList 選択中のテレメータ観測値過去情報
     */
    setSelectedTmPast(state, pastList) {
      Logger.debug("[Telemeter]mut - setSelectedTmPast(pastList)");
      Logger.dir(pastList);
      state.selectedTmPast = pastList;
    },
    /** [簡易カメラ]過去画像観測時間を更新する */
    setLatestScamTime(state, latestScamTime) {
      state.selectedTm.scamInfo.latestScamTime = latestScamTime;
    },
    /** 表示範囲の水位GeoJsonを更新する */
    setStgGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setStgGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.stgGeoJsons = telemeter;
    },
    /** 表示範囲のダムGeoJsonを更新する */
    setDamGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setDamGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.damGeoJsons = telemeter;
    },
    /** 表示範囲のカメラGeoJsonを更新する */
    setScamGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setScamGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.scamGeoJsons = telemeter;
    },
    /** 表示範囲の雨量GeoJsonを更新する */
    setRnGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setRnGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.rnGeoJsons = telemeter;
    },
    /** 表示範囲の水質GeoJsonを更新する */
    setQwtrGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setQwtrGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.qwtrGeoJsons = telemeter;
    },
    /** 表示範囲の海岸GeoJsonを更新する */
    setCoastGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setCoastGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.coastGeoJsons = telemeter;
    },
    /** 表示範囲の積雪GeoJsonを更新する */
    setSnwGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setSnwGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.snwGeoJsons = telemeter;
    },
    /** 表示範囲の危機管理型水位GeoJsonを更新する */
    setSwstgGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setSwstgGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.swstgGeoJsons = telemeter;
    },
    /** 表示範囲の基準観測所GeoJsonを更新する */
    setBaseobsGeoJsons(state, telemeter) {
      Logger.debug("[Telemeter]mut - setBaseobsGeoJsons(telemeter)");
      Logger.dir(telemeter);
      state.baseobsGeoJsons = telemeter;
    },
    /** GeoJson取得状態設定 */
    setGeoJsonGetStatus(state, { knd, status }) {
      Logger.debug(
        "[Telemeter]mut - setGeoJsonGetStatus(" + knd + "," + status + ")"
      );
      state.geoJsonGetStatus[knd] = status;
      state.geoJsonGetStatusTime = Util.toDate();
    },
    /** GeoJson取得状態クリア */
    clearGeoJsonGetStatus(state) {
      Logger.debug("[Telemeter]mut - clearGeoJsonGetStatus()");
      state.geoJsonGetStatus = {
        stg: false,
        dam: false,
        rn: false,
        qwtr: false,
        coast: false,
        snw: false,
        scam: false,
        swstg: false,
      };
    },
    /** 地点登録テレメータ情報設定 */
    setTmPointDatas(state, tmPointDatas) {
      Logger.debug("[Telemeter]mut - setTmPointDatas()");
      Logger.dir(tmPointDatas);
      state.tmPointDatas = tmPointDatas;
    },
    /** 地点登録 選択テレメータ情報 */
    setTmSelectedPointData(state, tmSelectedPointData) {
      Logger.debug(
        "[Telemeter]mut - setTmSelectedPointData(state, tmSelectedPointData)"
      );
      Logger.dir(tmSelectedPointData);
      state.tmSelectedPointData = tmSelectedPointData;
    },
    /** 地点登録 選択テレメータ対象日時情報 */
    setTmPointIndivDatas(state, tmPointIndivDatas) {
      Logger.debug("[Telemeter]mut -  setRpTmList(state, tmPointIndivDatas)");
      state.tmPointIndivDatas = tmPointIndivDatas;
    },
    /** API実行時のパラメータを設定 */
    setTmPointIndivDatasParam(state, appTime) {
      state.tmPointIndivDatasParam.dispTime = appTime;
    },
    /** 地点登録状況 */
    setRegistPointState(state, registPointState) {
      state.registPointState = registPointState;
    },
    /** 地点登録エラーメッセージ */
    setRegistPointErrMsg(state, registPointErrMsg) {
      state.registPointErrMsg = registPointErrMsg;
    },
    /** 地点登録メッセージ */
    setRegistPointMsg(state, registPointMsg) {
      state.registPointMsg = registPointMsg;
    },
    /** 地点登録パラメータ */
    setRegistPointParam(state, registPointParam) {
      state.registPointParam = registPointParam;
    },
    /** 水位観測所情報(追加)設定 */
    setTmStgAdditionalInfo(state, tmStgAdditionalInfo) {
      state.tmStgAdditionalInfo = tmStgAdditionalInfo;
    },
    /** 横断設定情報設定 */
    setSurfaceConf(state, surfaceConf) {
      Logger.debug("[Telemeter]mut - setSurfaceConf(state, surfaceConf)");
      Logger.dir(surfaceConf);
      state.surfaceConf = surfaceConf;
    },
    /** 観測所一覧表示モード(0:市町村別、1:水系別、2:基準値超過) */
    setObsListMode(state, data) {
      state.obsListMode = data;
    },
    /** 観測所表示設定
     * @param {*} state
     * @param {*} data
     */
    setSelectObsDisp(state, data) {
      state.selectObsDisp = data;
    },
    /** 拡縮表示設定
     * @param {*} state
     * @param {*} data
     */
    setScalMode(state, data) {
      state.scalMode = data;
    },
    /** [水位観測/水位計個別観測所]横断図拡縮表示設定
     * @param {*} state
     * @param {*} data
     */
    setScalModeXSec(state, data) {
      state.scalModeXSec = data;
    },
    /** [水位観測/水位計個別観測所]グラフ拡縮表示設定
     * @param {*} state
     * @param {*} data
     */
    setScalModeGraph(state, data) {
      state.scalModeGraph = data;
    },
    /** 表示時刻設定
     * @param {*} state
     * @param {*} data
     */
    setTimeMode(state, data) {
      state.timeMode = data;
    },
    /** 凡例表示状態
     * @param {*} state
     * @param {*} data
     */
    setLegendDisp(state, data) {
      state.isLegendDisp = data;
    },
    /** 選択中河川カメラ画像
     * @param {*} state
     * @param {*} data
     */
    setSelectCamera(state, data) {
      Logger.debug("[Telemeter]mut - setSelectCamera(state," + data + ")");
      state.selectCamera = data;
    },
    /** 最新観測値切替
     * @param {*} state
     * @param {*} data
     */
    setLatestObsIdx(state, data) {
      state.latestObsIdx = data;
    },
    /**
     * 個別観測所リセット
     */
    resetTmObs(state) {
      state.scalMode = false;
      state.scalModeXSec = true;
      state.scalModeGraph = false;
      state.timeMode = false;
      state.isLegendDisp = false;
      /** 河川予警報情報一覧 */
      state.obsDispStatus.riverWarnInfo = true;
      /** お知らせ情報一覧 */
      state.obsDispStatus.info = true;
      /** 観測所グラフ */
      state.obsDispStatus.obsGraph = true;
      /** 観測値一覧 */
      state.obsDispStatus.valuesList = true;
      /** グラフ切替 */
      /** 雨量グラフ */
      state.obsDispStatus.graphSwitch.rainGraph = true;
      /** 潮位グラフ */
      state.obsDispStatus.graphSwitch.tideGraph = true;
      /** 最大波グラフ */
      state.obsDispStatus.graphSwitch.maxWaveGraph = false;
      /** 1/3有義波グラフ */
      state.obsDispStatus.graphSwitch.onthWaveGraph = false;
      /** 風向・風速グラフ */
      state.obsDispStatus.graphSwitch.windGraph = false;
      /** 水質グラフ左軸 */
      state.obsDispStatus.graphSwitch.leftAxisGraph = 0;
      /** 水質グラフ右軸 */
      state.obsDispStatus.graphSwitch.rightAxisGraph = 0;
      /** 河川カメラ */
      state.obsDispStatus.cctv = true;
      /** 簡易カメラ */
      state.obsDispStatus.scam = true;
      /** 模式図 */
      state.obsDispStatus.diag = true;
      /** 断面図 */
      state.obsDispStatus.xsec = true;
    },
    /** 横断データ設定 */
    setSurface(state, surface) {
      Logger.debug("[Telemeter]mut - setSurface(state,surface)");
      Logger.dir(surface);
      state.surface = surface;
    },
    /** 履歴動画準備状態設定 */
    setHistoryPlayPrepStatus(state, prepStatus) {
      Logger.debug(
        "[Telemeter]mut - setHistoryPlayPrepStatus(" + prepStatus + ")"
      );
      state.historyPlayPrepStatus = prepStatus;
    },
    /** 観測所一覧選択タブ */
    setSelectTmListTabIndex(state, data) {
      Logger.debug("[Telemeter]mut - setSelectTmListTabIndex(" + data + ")");
      state.tmListTabIndex = data;
    },
    /** 観測所一覧全開閉フラグ */
    setTmListTwnFullOpenFlg(state, data) {
      state.tmListTwnFullOpenFlg = data;
    },
    /** 観測所一覧全開閉データ取得準備フラグ */
    setTmListTwnFullOpenReadyFlg(state, data) {
      state.tmListTwnFullOpenReadyFlg = data;
    },
    /** 観測所一覧全開閉完了フラグ */
    setTmListTwnFullOpenEndFlg(state, data) {
      state.tmListTwnFullOpenEndFlg = data;
    },
    /** 観測所一覧水系別全開閉フラグ */
    setTmListRsysFullOpenFlg(state, data) {
      state.tmlistRsysFullOpenFlg = data;
    },
    /** 観測所一覧水系別全開閉データ取得準備フラグ */
    setTmListRsysFullOpenReadyFlg(state, data) {
      state.tmListRsysFullOpenReadyFlg = data;
    },
    /** 観測所一覧水系別全開閉完了フラグ */
    setTmListRsysFullOpenEndFlg(state, data) {
      state.tmListRsysFullOpenEndFlg = data;
    },
    /** 都道府県市町村情報 */
    setPrefTmList(state, prefInfo) {
      Logger.debug("[Telemeter]mut - setPrefTmList(" + prefInfo + ")");
      // 都道府県情報を初期化
      state.prefTmList = {};
      state.prefTmList = prefInfo;
    },
    /** 表示都道府県市町村情報 */
    setDispPrefTmList(state, prefInfo) {
      Logger.debug("[Telemeter]mut - setDispPrefTmList(" + prefInfo + ")");
      state.dispPrefTmList = prefInfo;
    },
    /** 水系河川情報 */
    setRsysTmList(state, rsysInfo) {
      Logger.debug("[Telemeter]mut - setRsysTmList(" + rsysInfo + ")");
      // 水系河川情報を初期化
      state.rsysTmList = {};
      state.rsysTmList = rsysInfo;
    },
    /** 表示水系河川別観測所一覧情報 */
    setDispRsysTmList(state, rsysInfo) {
      Logger.debug("[Telemeter]mut - setDispRsysTmList(" + rsysInfo + ")");
      state.dispRsysTmList = rsysInfo;
    },
    /** 都道府県別：観測所情報追加 */
    updatePrefTmList(state, obsInfo) {
      Logger.debug("[Telemeter]mut - updatePrefTmList(" + obsInfo + ")");
      // 都道府県一覧情報を取得
      let prefTmList = state.prefTmList;
      // 都道府県一覧情報を初期化
      state.prefTmList = {};

      for (var i in prefTmList) {
        for (var j in prefTmList[i].twnInfo) {
          if (prefTmList[i].twnInfo[j].twnCd == obsInfo.twnCd) {
            // 都道府県、市町村コードが一致するデータにテレメータ情報を格納
            prefTmList[i].twnInfo[j].tmDetailInfo = obsInfo;
          }
        }
      }

      // 都道府県市町村別観測所情報を挿入
      state.prefTmList = prefTmList;
    },
    /** 水系河川別観測所情報に新規テレメータ情報を追加 */
    updateRsysTmList(state, obsInfo) {
      Logger.debug("[Telemeter]act - updateRsysTmList(" + obsInfo + ")");
      // 現在の水系河川別観測所情報
      let rsysTmList = state.rsysTmList;
      // 水系河川別観測所情報を初期化
      state.rsysTmList = {};

      for (var i in rsysTmList) {
        for (var j in rsysTmList[i].rvrInfo) {
          if (rsysTmList[i].rvrInfo[j].rvrCd == obsInfo.rvrCd) {
            //  河川コードが一致するデータにテレメータ情報を格納
            rsysTmList[i].rvrInfo[j].tmDetailInfo = obsInfo;
          }
        }
      }

      // 水系河川別観測所情報を挿入
      state.rsysTmList = rsysTmList;
    },
    setObsDispStatus(state, data) {
      state.obsDispStatus = data;
    },
    /** [MB]個別観測所画面が拡大されているかどうか(true OR false)を設定 */
    setMbTmObsIsExpansion(state, b) {
      state.mbTmObsIsExpansion = b;
    },
    /** 基準値超過テレメータ存在フラグを更新 */
    setTmOverExistenceFlg(state, flg) {
      Logger.debug("[Telemeter]mut - setTmOverExistenceFlg(" + flg + ")");
      state.tmOverExistenceFlg = flg;
    },
    /** [MB]基準値超過タブフラグを更新 */
    setTmOverListFlg(state, flg) {
      Logger.debug("[Telemeter]mut - setTmOverListFlg(" + flg + ")");
      state.tmOverListFlg = flg;
    },
    /** 登録APIの返却メッセージ */
    setApiMessage(state, apiMessage) {
      state.apiMessage = apiMessage;
    },
    /** 最新値ファイル用欠測判定時間 */
    setMissingTime(state, missingTime) {
      Logger.debug("[Telemeter]mut - setMissingTime(" + missingTime + ")");
      state.missingTime = missingTime;
    },
    /** 横断図SVGエラー情報設定 */
    setCrossSvgError(state, crossSvgError) {
      Logger.debug("[Telemeter]mut - setCrossSvgError(" + crossSvgError + ")");
      state.crossSvgError = crossSvgError;
    },
    setTmOverTypeFlg(state, typeFlg) {
      Logger.debug("[Telemeter]mut - setTmOverTypeFlg(" + typeFlg + ")");
      Logger.dir(typeFlg);
      state.typeFlg = typeFlg;
    },
    /** アクセスログ出力用パラメータ設定 */
    setPageLogParam(state, pageLogParam) {
      Logger.debug("[Telemeter]mut - setPageLogParam(pageLogParam)");
      Logger.dir(pageLogParam);
      state.pageLogParam = pageLogParam;
    },
    /** 地図アイコンからの遷移フラグを設定 */
    setMapIconFlg(state, data) {
      Logger.debug("[Telemeter]mut - setMapIconFlg(data)");
      Logger.dir(data);
      state.mapIconFlg = data;
    },
    /** 過去画像(取得確認用) */
    setHistoryPrintCurrentPicture(state, data) {
      Logger.debug("[Telemeter]mut - setHistoryPrintCurrentPicture(" + data + ")");
      state.historyPrintCurrentPicture = data;
    },
    /** 過去画像リセット */
    resetHistoryPrintCurrentPicture(state, data) {
      Logger.debug("[Telemeter]mut - resetHistoryPrintCurrentPicture(" + data + ")");
      state.historyPrintCurrentPicture = "";
    },
    /** スライダー関連 */
    // 取得した画像配列
    setArrayHistoryImages(state, array) {
      Logger.debug("[Telemeter]mut - setArrayHistoryImages(" + array + ")");
      state.historyImageSlider.arrayHistoryImages = array;
      // state.historyImageSlider.preloadedImages = {};
    },
    // 取得した画像時間配列
    setArrayHistoryAppTime(state, array) {
      Logger.debug("[Telemeter]mut - setArrayHistoryAppTime(" + array + ")");
      state.historyImageSlider.arrayHistoryAppTime = array;
    },
    // 取得した画像時間配列
    setSliderLabelTime(state, array) {
      Logger.debug("[Telemeter]mut - setSliderLabelTime(" + array + ")");
      state.historyImageSlider.sliderLabelTime = array;
    },
    // 取得した画像詳細時間配列
    setDetailTime(state, array) {
      Logger.debug("[Telemeter]mut - setDetailTime(" + array + ")");
      state.historyImageSlider.detailTime = array;
    },
    // 通常画面スライダーの現在位置
    setMovieCurrentIndex(state, i) {
      Logger.debug("[Telemeter]mut - setMovieCurrentIndex(" + i + ")");
      state.historyImageSlider.movieCurrentIndex = i;
    },
    // 拡大画面スライダーの現在位置
    setEnlargedMovieCurrentIndex(state, i) {
      Logger.debug("[Telemeter]mut - setEnlargedMovieCurrentIndex(" + i + ")");
      state.historyImageSlider.enlargedMovieCurrentIndex = i;
    },
    // 取得した画像時間配列の最後の時間(endTime)
    setMovieEndTime(state, data) {
      Logger.debug("[Telemeter]mut - setMovieEndTime(" + data + ")");
      state.historyImageSlider.movieEndTime = data;
    },
    // スライダーのステータス
    setHistoryPlayStatus(state, status) {
      Logger.debug("[Telemeter]mut - setHistoryPlayStatus(" + status + ")");
      state.historyImageSlider.historyPlayStatus = status;
    },
    // スライダーのステータス
    setEnlargeHistoryPlayStatus(state, status) {
      Logger.debug("[Telemeter]mut - setEnlargeHistoryPlayStatus(" + status + ")");
      state.historyImageSlider.enlargeHistoryPlayStatus = status;
    },
    // スライダー画像の再生フラグ
    setHistoryImageMovieFlg(state, flg) {
      Logger.debug("[Telemeter]mut - setHistoryImageMovieFlg(" + flg + ")");
      state.historyImageSlider.historyImageMovieFlg = flg;
    },
    // appTime変更に伴うロードの制御
    setAppTimeControlFlg(state, flg) {
      Logger.debug("[Telemeter]mut - setAppTimeControlFlg(" + flg + ")");
      state.historyImageSlider.appTimeControlFlg = flg;
    },
    // 画像拡大フラグ
    setExpandedScreeModal(state, flg) {
      Logger.debug("[Telemeter]mut - setExpandedScreeModal(" + flg + ")");
      state.historyImageSlider.expandedScreeModal = flg;
    },
    // スライダー画像不足フラグ
    // 動画素材取得のフラグ＝画像が取得済みか否かフラグ（動画再生していない状態で拡大したら画像の取得が必要なため）
    setSliderMissingImages(state, flg) {
      Logger.debug("[Telemeter]mut - setSliderMissingImages(" + flg + ")");
      state.historyImageSlider.sliderMissingImages = flg;
    },
    // プリロードされた画像の状態
    setPreloadImage(state, { index, isLoaded }) {
      Logger.debug("[Telemeter]mut - setPreloadImage(" + index + isLoaded + ")");
      state.historyImageSlider.preloadedImages[index] = isLoaded;
    },
    // 通常から拡大画面同期
    syncIndexes(state) {
      state.historyImageSlider.enlargedMovieCurrentIndex = state.historyImageSlider.movieCurrentIndex;
    },
    // 拡大から通常画面同期
    syncBackIndexes(state) {
      state.historyImageSlider.movieCurrentIndex = state.historyImageSlider.enlargedMovieCurrentIndex;
    },
    // 通常から拡大画面同期
    syncStatus(state) {
      state.historyImageSlider.enlargeHistoryPlayStatus = state.historyImageSlider.historyPlayStatus;
    },
    // 拡大から通常画面同期
    syncBackStatus(state) {
      state.historyImageSlider.historyPlayStatus = state.historyImageSlider.enlargeHistoryPlayStatus;
    },
    // 画面モード
    setViewMode(state, mode) {
      state.historyImageSlider.viewMode = mode;
    },
    setEnlargedView(state, flg) {
      state.historyImageSlider.isEnlargeView = flg;
    },
    /** 過去画像表示再生状態リセット */
    resetHistoryPlay(state) {
      Logger.debug("[Telemeter]mut - resetHistoryPlay()");
      state.historyImageSlider.historyPlayStatus = stateNone;
      state.historyImageSlider.enlargeHistoryPlayStatus = stateNone;
      state.historyImageSlider.movieCurrentIndex = 0;
      state.historyImageSlider.enlargedMovieCurrentIndex = 0;
      state.historyImageSlider.arrayHistoryImages = [];
      state.historyImageSlider.arrayHistoryAppTime = [];
      state.historyImageSlider.sliderLabelTime = [];
      state.historyImageSlider.detailTime = [];
      state.historyImageSlider.historyImageMovieFlg = false;
      state.historyImageSlider.appTimeControlFlg = false;
      state.historyImageSlider.sliderMissingImages = false;
      state.historyImageSlider.expandedScreeModal = false;
    },
  },
  actions: makeCancellable({
    /**
     * 高アクセス対応
     * 表示範囲内のテレメータ超過情報取得（市町村リスト）
     * @param {*} param0
     * @param appTime 対象日時
     * @param towns 市町村リスト
     * @param townsAcqTime 市町村リスト取得日時
     * @param isCurrent 観測日時[true: 最新, false: 履歴]
     * @param dispOvlvl 危機管理水位超過（危険水位）
     */
    getTmOvDatas: takeLatest(async function (
      { commit },
      { appTime, towns, townsAcqTime, isCurrent, dispOvlvl }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmOvDatas({*},{" +
          appTime +
          "," +
          towns +
          "," +
          townsAcqTime +
          "," +
          isCurrent +
          "," +
          dispOvlvl +
          "})"
      );
      let tmStg = [];
      let tmRn = [];
      let swStg = [];
      if (towns.length > 0) {
        // APIからデータ取得
        Logger.debug("[Telemeter]act - getTmOvDatas 情報取得");
        let list = [];
        for (let twn of towns) {
          list.push(twn.id);
        }
        for (let twnCd of list) {
          const { data } = await TelemeterJsonRepository.getTmOvDatasTwn(
            twnCd,
            appTime
          );
          // 基準値超過観測所一覧のリスト作成
          if (data != null) {
            let tmStgList = data.tmOverListResult.tmStg;
            let tmRnList = data.tmOverListResult.tmRn;
            let swStgList = data.tmOverListResult.swStg;
            // 通常水位リストの作成
            for (let i = 0; i < tmStgList.length; i++) {
              if (tmStgList[i] != null) {
                tmStg.push(tmStgList[i]);
              }
            }
            // 雨量リストの作成
            for (let r = 0; r < tmRnList.length; r++) {
              if (tmRnList[r] != null) {
                tmRn.push(tmRnList[r]);
              }
            }
            // 危機水位リストの作成
            for (let s = 0; s < swStgList.length; s++) {
              // 危機管理水位超過が80（危険水位）以上のデータを抽出
              if (
                swStgList[s] != null &&
                swStgList[s].swstgOvlvl >= dispOvlvl
              ) {
                swStg.push(swStgList[s]);
              }
            }
          }
        }
        Logger.debug("[Telemeter] getTmOvDatas()");
      }
      // 通常水位の超過観測所一覧のソート並び替え
      // 並び順：基準水位超過(降順)、水位変化量(降順)
      tmStg.sort(function (a, b) {
        if (a.stgOvlvl > b.stgOvlvl) return -1;
        if (a.stgOvlvl < b.stgOvlvl) return 1;
        if (a.stgChg > b.stgChg) return -1;
        if (a.stgChg < b.stgChg) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // // 雨量の超過観測所一覧のソート並び替え
      tmRn.sort(function (a, b) {
        if (a.rn60m > b.rn60m) return -1;
        if (a.rn60m < b.rn60m) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // 危機水位の超過観測所一覧のソート並び替え
      swStg.sort(function (a, b) {
        if (a.swstgOvlvl > b.swstgOvlvl) return -1;
        if (a.swstgOvlvl < b.swstgOvlvl) return 1;
        if (a.swobsCd > b.swobsCd) return 1;
        if (a.swobsCd < b.swobsCd) return -1;
        return 0;
      });
      let result = {
        tmStg: tmStg,
        tmRn: tmRn,
        swStg: swStg,
      };
      // パラメータをストアに格納
      commit("setTmOverDatasParam", {
        appTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得情報をストアに格納
      commit("setTmOverDatas", result);
    }),
    /**
     * 高アクセス対応
     * 表示範囲内のテレメータ超過情報取得（ 都道府県コードリスト）
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県コードリスト
     * @param dispOvlvl 危機管理水位超過（危険水位）
     */
    getTmOvDatasPref: takeLatest(async function (
      { commit },
      { appTime, prefs, townsAcqTime, isCurrent, dispOvlvl }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmOvDatasPref({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          isCurrent +
          "," +
          dispOvlvl +
          "})"
      );
      let tmStg = [];
      let tmRn = [];
      let swStg = [];
      if (prefs.length > 0) {
        // APIからデータ取得
        Logger.debug("[Telemeter]act - getTmOvDatasPref 情報取得");
        Logger.dir(prefs);
        let list = [];
        for (let pref of prefs) {
          list.push(pref.id);
        }
        for (let prefCd of list) {
          const { data } = await TelemeterJsonRepository.getTmOvDatasPref(
            prefCd,
            appTime
          );
          // 基準値超過観測所一覧のリスト作成
          if (data != null) {
            let tmStgList = data.tmOverListResult.tmStg;
            let tmRnList = data.tmOverListResult.tmRn;
            let swStgList = data.tmOverListResult.swStg;
            // 通常水位リストの作成
            for (let i = 0; i < tmStgList.length; i++) {
              if (tmStgList[i] != null) {
                tmStg.push(tmStgList[i]);
              }
            }
            // 雨量リストの作成
            for (let r = 0; r < tmRnList.length; r++) {
              if (tmRnList[r] != null) {
                tmRn.push(tmRnList[r]);
              }
            }
            // 危機水位リストの作成
            for (let s = 0; s < swStgList.length; s++) {
              // 危機管理水位超過が80（危険水位）以上のデータを抽出
              if (
                swStgList[s] != null &&
                swStgList[s].swstgOvlvl >= dispOvlvl
              ) {
                swStg.push(swStgList[s]);
              }
            }
          }
        }
        Logger.debug("[Telemeter] getTmOvDatasPref()");
      }
      // 通常水位の超過観測所一覧のソート並び替え
      // 並び順：基準水位超過(降順)、水位変化量(降順)
      tmStg.sort(function (a, b) {
        if (a.stgOvlvl > b.stgOvlvl) return -1;
        if (a.stgOvlvl < b.stgOvlvl) return 1;
        if (a.stgChg > b.stgChg) return -1;
        if (a.stgChg < b.stgChg) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // // 雨量の超過観測所一覧のソート並び替え
      tmRn.sort(function (a, b) {
        if (a.rn60m > b.rn60m) return -1;
        if (a.rn60m < b.rn60m) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // 危機水位の超過観測所一覧のソート並び替え
      swStg.sort(function (a, b) {
        if (a.swstgOvlvl > b.swstgOvlvl) return -1;
        if (a.swstgOvlvl < b.swstgOvlvl) return 1;
        if (a.swobsCd > b.swobsCd) return 1;
        if (a.swobsCd < b.swobsCd) return -1;
        return 0;
      });
      let result = {
        tmStg: tmStg,
        tmRn: tmRn,
        swStg: swStg,
      };
      // パラメータをストアに格納
      commit("setTmOverDatasParam", {
        appTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得情報をストアに格納
      commit("setTmOverDatas", result);
    }),
    /**
     * 高アクセス対応
     * 表示範囲内のテレメータ超過情報取得（緯度経度）
     * @param {*} param0
     * @param appTime 対象日時
     * @param minlat 左下緯度
     * @param minlon 左下経度
     * @param mxnlat 右上緯度
     * @param mxnlon 右上経度
     * @param zm ズーム倍率
     * @param dispOvlvl 危機管理水位超過（危険水位）
     */
    async getTmOvDatasByLatLon(
      { commit },
      { zm, appTime, minlat, minlon, maxlat, maxlon, dispOvlvl }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmOvDatasByLatLon({*},{" +
          appTime +
          "," +
          minlat +
          "," +
          minlon +
          "," +
          maxlat +
          "," +
          maxlon +
          "," +
          dispOvlvl +
          "})"
      );
      let tmStg = [];
      let tmRn = [];
      let swStg = [];
      if (zm <= 11) {
        // 都道府県判定リスト
        const { data: prefData, prefError } =
          await MapJsonRepository.getPrefList();
        Logger.debug("[Telemeter] getPrefList()");
        let prefs = [];
        if (!prefError) {
          var prefJudgeList = prefData.prefs;
        }
        prefJudgeList.forEach((pref) => {
          // 取得範囲内の都道府県に絞る
          let pushFlg = true;
          // 小数点計算の誤差を無くすため10*9倍にして計算する
          if (pref.maxLat * Math.pow(10, 9) < minlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (pref.maxLon * Math.pow(10, 9) < minlon * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (pref.minLat * Math.pow(10, 9) > maxlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (pref.minLon * Math.pow(10, 9) > maxlon * Math.pow(10, 9)) {
            pushFlg = false;
          }
          if (pushFlg) {
            prefs.push(pref.prefCd);
          }
        });
        // APIからデータ取得
        for (var prefCd of prefs) {
          const { data } = await TelemeterJsonRepository.getTmOvDatasPref(
            prefCd,
            appTime
          );
          // 基準値超過観測所一覧のリスト作成
          if (data != null) {
            let tmStgList = data.tmOverListResult.tmStg;
            let tmRnList = data.tmOverListResult.tmRn;
            let swStgList = data.tmOverListResult.swStg;
            // 通常水位リストの作成
            for (let i = 0; i < tmStgList.length; i++) {
              if (tmStgList[i] != null) {
                tmStg.push(tmStgList[i]);
              }
            }
            // 雨量リストの作成
            for (let r = 0; r < tmRnList.length; r++) {
              if (tmRnList[r] != null) {
                tmRn.push(tmRnList[r]);
              }
            }
            // 危機水位リストの作成
            for (let s = 0; s < swStgList.length; s++) {
              // 危機管理水位超過が80（危険水位）以上のデータを抽出
              if (
                swStgList[s] != null &&
                swStgList[s].swstgOvlvl >= dispOvlvl
              ) {
                swStg.push(swStgList[s]);
              }
            }
          }
        }
        Logger.debug("[Telemeter] getTmOvDatasPref()");
      } else {
        // 市町村判定リスト
        const { data: townData, townError } =
          await MapJsonRepository.getTownList();
        Logger.debug("[Telemeter] getTownList()");
        let towns = [];
        if (!townError) {
          var twonJudgeList = townData.towns;
        }
        twonJudgeList.forEach((town) => {
          // 取得範囲内の市町村に絞る
          let pushFlg = true;
          // 小数点計算の誤差を無くすため10*9倍にして計算する
          if (town.maxLat * Math.pow(10, 9) < minlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.maxLon * Math.pow(10, 9) < minlon * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.minLat * Math.pow(10, 9) > maxlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.minLon * Math.pow(10, 9) > maxlon * Math.pow(10, 9)) {
            pushFlg = false;
          }
          if (pushFlg) {
            towns.push(town.twnCd);
          }
        });
        // APIからデータ取得
        for (var twnCd of towns) {
          const { data } = await TelemeterJsonRepository.getTmOvDatasTwn(
            twnCd,
            appTime
          );
          // 基準値超過観測所一覧のリスト作成
          if (data != null) {
            let tmStgList = data.tmOverListResult.tmStg;
            let tmRnList = data.tmOverListResult.tmRn;
            let swStgList = data.tmOverListResult.swStg;
            // 通常水位リストの作成
            for (let i = 0; i < tmStgList.length; i++) {
              if (tmStgList[i] != null) {
                tmStg.push(tmStgList[i]);
              }
            }
            // 雨量リストの作成
            for (let r = 0; r < tmRnList.length; r++) {
              if (tmRnList[r] != null) {
                tmRn.push(tmRnList[r]);
              }
            }
            // 危機水位リストの作成
            for (let s = 0; s < swStgList.length; s++) {
              // 危機管理水位超過が80（危険水位）以上のデータを抽出
              if (
                swStgList[s] != null &&
                swStgList[s].swstgOvlvl >= dispOvlvl
              ) {
                swStg.push(swStgList[s]);
              }
            }
          }
        }
        Logger.debug("[Telemeter] getTmOvDatasTwn()");
      }
      // 通常水位の超過観測所一覧のソート並び替え
      // 並び順：基準水位超過(降順)、水位変化量(降順)
      tmStg.sort(function (a, b) {
        if (a.stgOvlvl > b.stgOvlvl) return -1;
        if (a.stgOvlvl < b.stgOvlvl) return 1;
        if (a.stgChg > b.stgChg) return -1;
        if (a.stgChg < b.stgChg) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // // 雨量の超過観測所一覧のソート並び替え
      tmRn.sort(function (a, b) {
        if (a.rn60m > b.rn60m) return -1;
        if (a.rn60m < b.rn60m) return 1;
        if (a.obsFcd > b.obsFcd) return 1;
        if (a.obsFcd < b.obsFcd) return -1;
        return 0;
      });
      // 危機水位の超過観測所一覧のソート並び替え
      swStg.sort(function (a, b) {
        if (a.swstgOvlvl > b.swstgOvlvl) return -1;
        if (a.swstgOvlvl < b.swstgOvlvl) return 1;
        if (a.swobsCd > b.swobsCd) return 1;
        if (a.swobsCd < b.swobsCd) return -1;
        return 0;
      });
      let result = {
        tmStg: tmStg,
        tmRn: tmRn,
        swStg: swStg,
      };

      // パラメータをストアに格納
      commit("setAppTimeParam", appTime);
      // 取得情報をストアに格納
      commit("setTmOverDatas", result);
    },
    /**
     * 地点登録のテレメータ情報取得
     * @param {*} param0
     * @param {*} pointIndex
     * @param {*} name 地点名
     * @param {*} lat 緯度
     * @param {*} lon 経度
     * @param {*} centerTwn 中心の市町村情報
     * @param {*} centerHeight 中心の標高
     * @param {*} minLatLon 周辺観測所の範囲の最小緯度経度
     * @param {*} maxLatLon 周辺観測所の範囲の最大緯度経度
     * @param {*} zoom ズームレベル
     * @param {*} token トークン
     * @param {*} iconImg アイコン画像
     * @param {*} iconSize アイコンサイズ
     */
    async getTmDatasByPoint(
      { state, commit },
      {
        pointIndex,
        name,
        center: [lat, lon],
        centerTwn,
        centerHeight,
        minLatLon,
        maxLatLon,
        zoom,
        token,
        iconImg,
        iconSize,
      }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmDatasByPoint({*},{" +
          pointIndex +
          "," +
          name +
          "," +
          lat +
          "," +
          lon +
          "," +
          centerTwn +
          "," +
          centerHeight +
          "," +
          minLatLon[0] +
          "," +
          minLatLon[1] +
          "," +
          maxLatLon[0] +
          "," +
          maxLatLon[1] +
          "," +
          zoom +
          "," +
          token +
          "," +
          iconImg +
          "," +
          iconSize +
          "})"
      );

      let date = Util.toDate();
      // パラメータを保持
      commit("setRegistPointParam", {
        pointIndex: pointIndex,
        lat: lat,
        lon: lon,
        date: date,
      });

      commit("setRegistPointErrMsg", "");
      commit("setRegistPointMsg", "");

      // 地点登録状況 0:登録開始
      commit("setRegistPointState", 0);

      // [浸水想定API]3時間以内に浸水深50cmになる破堤点取得
      Logger.debug(
        "[Telemeter]act - getTmDatasByPoint [浸水想定API]3時間以内に浸水深50cmになる破堤点取得"
      );
      const { data: promiseBP180min, error: error180min50cm } =
        await IuRepository.getBreakPoints180min50cm(lat, lon);
      Logger.debug("[Telemeter]act - getTmDatasByPoint promiseBP180min.data");
      Logger.dir(promiseBP180min);
      Logger.dir(error180min50cm);
      if (error180min50cm) {
        commit("setRegistPointParam", {});
        commit(
          "setRegistPointErrMsg",
          "浸水ナビでリスク判定ができませんでした。時間をおいてやり直してください。"
        );
        return;
      }

      // キャンセル判定
      if (state.registPointState === 9) {
        commit("setRegistPointState", 0);
        commit("setRegistPointParam", {});
        commit("setRegistPointErrMsg", "");
      } else if (
        (state.registPointParam.pointIndex &&
          state.registPointParam.pointIndex !== pointIndex) ||
        (state.registPointParam.lat && state.registPointParam.lat !== lat) ||
        (state.registPointParam.lon && state.registPointParam.lon !== lon) ||
        (state.registPointParam.date && state.registPointParam.date !== date)
      ) {
        return;
      }

      // 地点登録状況 1:3時間以内に浸水深50cmになる破堤点取得 完了
      commit("setRegistPointState", 1);

      let bp180min = [];

      // 河川毎の破堤点の緯度経度をmapに登録
      let mapRvr = new Map();

      if (promiseBP180min != null) {
        for (let bp180m of promiseBP180min) {
          bp180min.push({
            bpName: bp180m.BPName,
            bpLocation: bp180m.BPLocation,
            latlon: [bp180m.BPLat, bp180m.BPLon],
            riverName: bp180m.EntryRiverName,
            riverCd: bp180m.RiverCode,
          });
          if (mapRvr.has(bp180m.RiverCode)) {
            mapRvr
              .get(bp180m.RiverCode)
              .push({ lat: bp180m.BPLat, lon: bp180m.BPLon });
          } else {
            mapRvr.set(bp180m.RiverCode, [
              {
                lat: bp180m.BPLat,
                lon: bp180m.BPLon,
              },
            ]);
          }
        }
      }

      // [浸水想定API]河川毎最大浸水深取得からデータ取得
      Logger.debug(
        "[Telemeter]act - getMaxDepthFromLatlon [浸水想定API]河川毎最大浸水深取得"
      );
      const { data: promiseDepth, error: errorDepth } =
        await IuRepository.getMaxDepthFromLatlon(lat, lon);
      Logger.debug("[Telemeter]act - getMaxDepthFromLatlon 取得結果");
      Logger.dir(promiseDepth);
      Logger.dir(errorDepth);
      if (errorDepth) {
        commit("setRegistPointParam", {});
        commit(
          "setRegistPointErrMsg",
          "浸水ナビでリスク判定ができませんでした。時間をおいてやり直してください。"
        );
        return;
      }

      // キャンセル判定
      if (state.registPointState === 9) {
        commit("setRegistPointState", 0);
        commit("setRegistPointParam", {});
        commit("setRegistPointErrMsg", "");
      } else if (
        (state.registPointParam.pointIndex &&
          state.registPointParam.pointIndex !== pointIndex) ||
        (state.registPointParam.lat && state.registPointParam.lat !== lat) ||
        (state.registPointParam.lon && state.registPointParam.lon !== lon) ||
        (state.registPointParam.date && state.registPointParam.date !== date)
      ) {
        return;
      }
      // 地点登録状況 2:河川毎最大浸水深取得 完了
      commit("setRegistPointState", 2);

      // [浸水想定API]河川毎最速到達時間取得からデータ取得
      Logger.debug(
        "[Telemeter]act - getMaxArriveFromLatlon [浸水想定API]河川毎最速到達時間"
      );
      const { data: promiseArrive, error: errorArrive } =
        await IuRepository.getMaxArriveFromLatlon(lat, lon);
      Logger.debug("[Telemeter]act - getMaxArriveFromLatlon 取得結果");
      Logger.dir(promiseArrive);
      Logger.dir(errorArrive);
      if (errorArrive) {
        commit("setRegistPointParam", {});
        commit(
          "setRegistPointErrMsg",
          "浸水ナビでリスク判定ができませんでした。時間をおいてやり直してください。"
        );
        return;
      }

      // キャンセル判定
      if (state.registPointState === 9) {
        commit("setRegistPointState", 0);
        commit("setRegistPointParam", {});
        commit("setRegistPointErrMsg", "");
      } else if (
        (state.registPointParam.pointIndex &&
          state.registPointParam.pointIndex !== pointIndex) ||
        (state.registPointParam.lat && state.registPointParam.lat !== lat) ||
        (state.registPointParam.lon && state.registPointParam.lon !== lon) ||
        (state.registPointParam.date && state.registPointParam.date !== date)
      ) {
        return;
      }
      // 地点登録状況 3:河川毎最速到達時間 完了
      commit("setRegistPointState", 3);

      // [浸水想定API]河川毎最大継続時間取得からデータ取得
      Logger.debug(
        "[Telemeter]act - getMaxArriveFromLatlon [浸水想定API]河川毎最大継続時間"
      );
      const { data: promiseContinue, error: errorContinue } =
        await IuRepository.getMaxContinueFromLatlon(lat, lon);
      Logger.debug("[Telemeter]act - getMaxContinueFromLatlon 取得結果");
      Logger.dir(promiseContinue);
      Logger.dir(errorContinue);
      if (errorContinue) {
        commit("setRegistPointParam", {});
        commit(
          "setRegistPointErrMsg",
          "浸水ナビでリスク判定ができませんでした。時間をおいてやり直してください。"
        );
        return;
      }

      // キャンセル判定
      if (state.registPointState === 9) {
        commit("setRegistPointState", 0);
        commit("setRegistPointParam", {});
        commit("setRegistPointErrMsg", "");
      } else if (
        (state.registPointParam.pointIndex &&
          state.registPointParam.pointIndex !== pointIndex) ||
        (state.registPointParam.lat && state.registPointParam.lat !== lat) ||
        (state.registPointParam.lon && state.registPointParam.lon !== lon) ||
        (state.registPointParam.date && state.registPointParam.date !== date)
      ) {
        return;
      }
      // 地点登録状況 4:河川毎最大継続時間 完了
      commit("setRegistPointState", 4);

      let breakPoint = [];
      // 河川毎最大浸水深取得を追加
      if (promiseDepth != null) {
        let listDepth;

        if (promiseDepth.EntryRiverName) {
          listDepth = [promiseDepth];
        } else {
          listDepth = promiseDepth;
        }
        for (var dataDepth of listDepth) {
          breakPoint.push({
            lat: dataDepth.BPLat,
            lon: dataDepth.BPLon,
            riverCd: dataDepth.RiverCode,
            riverName: dataDepth.EntryRiverName,
            depthMax: dataDepth.Depth,
          });
        }
      }
      if (promiseArrive != null) {
        // 河川毎最大浸水深取得を追加
        let listArrive;
        if (promiseArrive.EntryRiverName) {
          listArrive = [promiseArrive];
        } else {
          listArrive = promiseArrive;
        }
        for (let dataArrive of listArrive) {
          let isNew = true;
          for (let point of breakPoint) {
            if (dataArrive.RiverCode == point.riverCd) {
              isNew = false;
              point.startTime = dataArrive.ArriveTime;
              break;
            }
          }
          if (isNew) {
            breakPoint.push({
              lat: dataArrive.BPLat,
              lon: dataArrive.BPLon,
              riverCd: dataArrive.RiverCode,
              riverName: dataArrive.EntryRiverName,
              startTime: dataArrive.ArriveTime,
            });
          }
        }
      }

      // 河川毎最大継続時間を追加
      if (promiseContinue != null) {
        let listContinue;
        if (promiseArrive.EntryRiverName) {
          listContinue = [promiseContinue];
        } else {
          listContinue = promiseContinue;
        }
        for (let dataContinue of listContinue) {
          let isNew = true;
          for (let point of breakPoint) {
            if (dataContinue.RiverCode == point.riverCd) {
              isNew = false;
              point.time0_5Continue = dataContinue.ContinueTime;
              break;
            }
          }
          if (isNew) {
            breakPoint.push({
              lat: dataContinue.BPLat,
              lon: dataContinue.BPLon,
              riverCd: dataContinue.RiverCode,
              riverName: dataContinue.EntryRiverName,
              time0_5Continue: dataContinue.ContinueTime,
            });
          }
        }
      }

      // 国交省河川から統一河川へ変換
      for (var point of breakPoint) {
        if (point.riverCd) {
          const { data: conv } = await TelemeterJsonRepository.getConvRvrCd(
            point.riverCd
          );

          if (conv && conv.rvrCnv) {
            point.rvrCnv = conv.rvrCnv;
          }
        }
      }
      Logger.debug("[Telemeter]act - getMaxArriveFromLatlon breakPoint");
      Logger.dir(breakPoint);

      // 関連観測所取得(登録地点から一定距離)
      let bounds = geodesic.getBounds(
        [lat, lon],
        state.crossConfig.pointDistance
      );

      Logger.debug(
        "[Telemeter]act - getTmDatasByPoint 関連観測所取得(登録地点から一定距離)"
      );

      const promisePoint = await TelemeterRepository.getTmPointDatas(
        bounds.minCoord[0],
        bounds.maxCoord[0],
        bounds.minCoord[1],
        bounds.maxCoord[1]
      );
      let tmDatasPoint = promisePoint.data.result.tmPoint;
      let swPoint = promisePoint.data.result.swPoint;
      let scamPoint = promisePoint.data.result.scamPoint;

      Logger.debug("[Telemeter]act - getTmDatasByPoint tmDatasPoint");
      Logger.dir(tmDatasPoint);
      Logger.debug("[Telemeter]act - getTmDatasByPoint swPoint");
      Logger.dir(swPoint);
      Logger.debug("[Telemeter]act - getTmDatasByPoint scamPoint");
      Logger.dir(scamPoint);

      // 周辺観測所
      var tmPoint = [];
      if (tmDatasPoint != null && tmDatasPoint.length > 0) {
        // 登録地点の周辺観測所がある場合は、周辺観測所に設定
        tmPoint = tmDatasPoint;
      }

      // APIの引数となる、河川コード・緯度・経度の配列
      let rvrCd = [];
      let minLat = [];
      let minLon = [];
      let maxLat = [];
      let maxLon = [];

      for (let key of mapRvr.keys()) {
        let rvrVal = mapRvr.get(key);
        // 河川毎の最小最大の緯度経度をそれぞれ取得
        let rMinLat = 0;
        let rMinLon = 0;
        let rMaxLat = 0;
        let rMaxLon = 0;
        for (let location of rvrVal) {
          if (rMinLat === 0 || rMinLat > location.lat) {
            rMinLat = location.lat;
          }
          if (rMinLon === 0 || rMinLon > location.lon) {
            rMinLon = location.lon;
          }
          if (rMaxLat === 0 || rMaxLat < location.lat) {
            rMaxLat = location.lat;
          }
          if (rMaxLon === 0 || rMaxLon < location.lon) {
            rMaxLon = location.lon;
          }
        }
        rvrCd.push(key);
        minLat.push(rMinLat);
        minLon.push(rMinLon);
        maxLat.push(rMaxLat);
        maxLon.push(rMaxLon);
      }

      if (rvrCd.length > 0) {
        // 緯度経度から設定ファイルの距離の範囲内の座標を取得
        for (var idxRvr = 0; idxRvr < rvrCd.length; idxRvr++) {
          var boundsMin = geodesic.getBounds(
            [minLat[idxRvr], minLon[idxRvr]],
            state.crossConfig.breakDistance
          );
          minLat[idxRvr] = boundsMin.minCoord[0];
          minLon[idxRvr] = boundsMin.minCoord[1];

          var boundsMax = geodesic.getBounds(
            [maxLat[idxRvr], maxLon[idxRvr]],
            state.crossConfig.breakDistance
          );
          maxLat[idxRvr] = boundsMax.maxCoord[0];
          maxLon[idxRvr] = boundsMax.maxCoord[1];
        }

        Logger.debug(
          "[Telemeter]act - getTmDatasByPoint 関連観測所取得(破堤点から一定距離で同一河川)"
        );
        const promiseBreak = await TelemeterRepository.getTmPointDatasBp(
          minLat,
          maxLat,
          minLon,
          maxLon,
          rvrCd
        );

        if (promiseBreak.data != null) {
          // 関連観測所をマージ
          var tmDatasBreak = promiseBreak.data.result.tmPoint;
          if (tmDatasBreak != null && tmDatasBreak.length > 0) {
            for (var tmBk of tmDatasBreak) {
              var isEntryObs = false;
              for (var tmP of tmPoint) {
                if (
                  tmBk.ofcCd === tmP.ofcCd &&
                  tmBk.itmkndCd === tmP.itmkndCd &&
                  tmBk.obsCd === tmP.obsCd
                ) {
                  isEntryObs = true;
                  continue;
                }
              }
              // 未登録の場合は追加
              if (!isEntryObs) {
                tmPoint.push(tmBk);
              }
            }
          }
          // 危機管理型水位計をマージ
          var swDatasBreak = promiseBreak.data.result.swPoint;
          if (swDatasBreak != null && swDatasBreak.length > 0) {
            for (var swBk of swDatasBreak) {
              var isEntrySw = false;
              for (var swP of swPoint) {
                if (swBk.swobsCd === swP.swobsCd) {
                  isEntrySw = true;
                  continue;
                }
              }
              // 未登録の場合は追加
              if (!isEntrySw) {
                swPoint.push(swBk);
              }
            }
          }
          // 簡易カメラをマージ
          var scamDatasBreak = promiseBreak.data.result.scamPoint;
          if (scamDatasBreak != null && scamDatasBreak.length > 0) {
            for (var scamBk of scamDatasBreak) {
              var isEntryScam = false;
              for (var pScam of scamPoint) {
                if (scamBk.scamId === pScam.scamId) {
                  isEntryScam = true;
                  break;
                }
              }
              // 未登録の場合は追加
              if (!isEntryScam) {
                scamPoint.push(scamBk);
              }
            }
          }
        }
      }

      // 関連観測所をDB登録用に成形する
      let obsList = [];
      // 現状では通知対象外として登録する
      // for (let obs of tmPoint) {
      //   if (obs.itmkndCd === 1 || obs.itmkndCd === 4) {
      //     obsList.push(
      //       ("0000" + obs.ofcCd).slice(-5) +
      //         ("00" + obs.itmkndCd).slice(-3) +
      //         ("0000" + obs.obsCd).slice(-5)
      //     );
      //   }
      // }
      // 関連危機管理型水位計をDB登録用に成形する
      let swobsList = [];
      // for (let sw of swPoint) {
      //   swobsList.push(sw.swobsCd);
      // }

      // トークンがある場合は、登録APIを呼び出し
      if (token && token !== "") {
        const { data: retResist } = await TelemeterRepository.registPoint(
          pointIndex,
          token,
          centerTwn.townCd,
          obsList,
          swobsList
        );

        Logger.debug("[Telemeter]act - getTmDatasByPoint 地点登録情報のDB登録");
        Logger.dir(retResist);
      }

      // TMの距離・通知を設定
      if (tmPoint != null) {
        for (var idx = 0; idx < tmPoint.length; idx++) {
          var distance = geodesic.getDistance(
            [lat, lon],
            [tmPoint[idx].lat, tmPoint[idx].lon]
          );
          tmPoint[idx].distance = Math.round(distance * 10) / 10;
          // 現状では通知対象外として登録する
          // if (tmPoint[idx].itmkndCd === 1 || tmPoint[idx].itmkndCd === 4) {
          //   tmPoint[idx].notice = true;
          // } else {
          //   tmPoint[idx].notice = false;
          // }
          tmPoint[idx].notice = false;
        }
      }

      // SWの距離・通知を設定
      if (swPoint != null) {
        for (var idxSw = 0; idxSw < swPoint.length; idxSw++) {
          var distanceSw = geodesic.getDistance(
            [lat, lon],
            [swPoint[idxSw].lat, swPoint[idxSw].lon]
          );
          swPoint[idxSw].distance = Math.round(distanceSw * 10) / 10;
          // 現状では通知対象外として登録する
          // swPoint[idxSw].notice = true;
          swPoint[idxSw].notice = false;
        }
      }

      // 簡易カメラの距離を設定
      if (scamPoint != null) {
        for (var idxScam = 0; idxScam < scamPoint.length; idxScam++) {
          var distanceScam = geodesic.getDistance(
            [lat, lon],
            [scamPoint[idxScam].lat, scamPoint[idxScam].lon]
          );
          scamPoint[idxScam].distance = Math.round(distanceScam * 10) / 10;
        }
      }

      let address = centerTwn.address;
      if (!address) {
        address = centerTwn.prefNm + centerTwn.townNm;
      }

      let pointInfo = {
        pointIndex: pointIndex,
        name: name,
        center: [lat, lon],
        centerHeight: centerHeight,
        twnCd: centerTwn.townCd,
        prefCd: centerTwn.prefCd,
        address: address,
        risk: true,
        luDatas: breakPoint,
        tmDatas: {
          tmPoint: tmPoint,
          swPoint: swPoint,
          scamPoint: scamPoint,
        },
        bpDatas: bp180min,
        zoom: zoom,
        iconImg: iconImg,
        iconSize: iconSize,
      };

      Logger.debug("[Telemeter]act - getTmDatasByPoint pointInfo");
      Logger.dir(pointInfo);

      if (promiseBP180min === null || promiseBP180min.length == 0) {
        commit(
          "setRegistPointMsg",
          "浸水ナビでリスク判定ができませんでした。お住いの自治体のハザードマップをご確認ください。"
        );
      }

      // 取得情報をストアに格納
      commit("setTmPointDatas", pointInfo);

      // 地点登録のパラメータを初期化
      commit("setRegistPointParam", {});

      // 地点登録状況 2:地点登録 完了
      commit("setRegistPointState", 5);
    },

    /**
     * 通知情報の変更をDBに反映
     */
    async changeNotice({ commit }, { pointNo, token, selectedPoint }) {
      Logger.debug(
        "[Telemeter]act - changeNotice(commit," +
          pointNo +
          "," +
          token +
          "," +
          selectedPoint +
          ")"
      );
      if (token && token !== "") {
        // 現状では通知対象外として登録する
        let obslist = [];
        // for (let tm of selectedPoint.tmDatas.tmPoint) {
        //   if (tm.notice) {
        //     obslist.push(
        //       ("0000" + tm.ofcCd).slice(-5) +
        //         ("00" + tm.itmkndCd).slice(-3) +
        //         ("0000" + tm.obsCd).slice(-5)
        //     );
        //   }
        // }
        // 現状では通知対象外として登録する
        let swobslist = [];
        // for (let sw of selectedPoint.tmDatas.swPoint) {
        //   if (sw.notice) {
        //     swobslist.push(sw.swobsCd);
        //   }
        // }
        // DB登録
        const { data } = await TelemeterRepository.changeNotice(
          pointNo + 1,
          token,
          obslist,
          swobslist
        );

        Logger.debug("[Telemeter]changeNotice");
        commit("setApiMessage", data.result);
      }
    },
    /**
     * 登録地点の削除ををDBに反映
     */
    async deletePoint({ commit }, { pointNo, token }) {
      Logger.debug(
        "[Telemeter]act - deletePoint(commit," + pointNo + "," + token + ")"
      );

      if (token && token !== "") {
        // DB削除
        const { data } = await TelemeterRepository.deletePoint(pointNo, token);

        Logger.debug("[Telemeter]deletePoint");
        commit("setApiMessage", data.result);
      }
    },
    /**
     * 地点登録の選択中テレメータとして登録する情報を取得
     * @param {*} param0
     * @param {*} param1
     */
    async getTmSelectedPointData(
      { commit },
      { ofcCd, itmkndCd, obsCd, lat, lon, distance }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmSelectedPointData(commit," +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          "," +
          lat +
          "," +
          lon +
          "," +
          distance +
          ")"
      );

      // 伝送記号
      let obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);

      let payload = {
        itmkndCd: itmkndCd,
        obsFcd: obsFcd,
      };

      // 観測所データ取得
      const { data: obsData } = await TelemeterJsonRepository.getSelectedObs(
        payload
      );

      // パラメータをデータに追加
      obsData.obsInfo.lat = lat;
      obsData.obsInfo.lon = lon;
      obsData.obsInfo.distance = distance;

      // 情報をストアに格納
      commit("setTmSelectedPointData", obsData.obsInfo);
    },
    /**
     * 地点登録の選択中CCTVとして登録する情報を取得
     * @param {*} param0
     * @param {*} param1
     */
    async getTmSelectedPointCctvData(
      { commit },
      { ofcCd, cctvCd, lat, lon, distance }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmSelectedPointCctvData(commit," +
          ofcCd +
          "," +
          cctvCd +
          "," +
          lat +
          "," +
          lon +
          "," +
          distance +
          ")"
      );
      // APIからデータ取得
      const { data } = await TelemeterRepository.getTmPointCctvData(
        ofcCd,
        cctvCd
      );

      // パラメータをデータに追加
      data.cctvPointResult.cctvPoint.lat = lat;
      data.cctvPointResult.cctvPoint.lon = lon;
      data.cctvPointResult.cctvPoint.distance = distance;

      // 情報をストアに格納
      commit("setTmSelectedPointData", data.cctvPointResult.cctvPoint);
    },

    /**
     * 表示範囲の水位GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param getOverFlg 基準値超過GeoJson取得フラグ
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getStgGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, getOverFlg, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getStgGeoJsons(towns,getTimeList," +
          getOverFlg +
          ",townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "stg", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmOverGeoJsonInfo = null;
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 基準値超過GeoJSON取得
        if (getOverFlg) {
          Logger.debug("[Telemeter]API - getStgOverGeoJsons(" + dateTime + ")");
          // APIからデータ取得
          const { data, error } =
            await TelemeterGeojsonRepository.getStgOverGeoJsons(dateTime);
          Logger.debug(
            "[Telemeter]API - getStgOverGeoJsons(" + dateTime + ") - return"
          );
          Logger.dir(data);
          Logger.dir(error);
          if (!error) {
            tmOverGeoJsonInfo = data;
          }
        }
        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }

        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.stgExistFlg == 1
            );
          }
          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getStgObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getStgObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getStgObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmOverGeoJsonInfo: tmOverGeoJsonInfo,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setStgGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "stg", status: true });
    }),

    /**
     * 表示範囲のダムGeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param getOverFlg 基準値超過GeoJson取得フラグ
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getDamGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, getOverFlg, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getDamGeoJsons(towns,getTimeList," +
          getOverFlg +
          ",townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "dam", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmOverGeoJsonInfo = null;
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 基準値超過GeoJSON取得
        if (getOverFlg) {
          Logger.debug("[Telemeter]API - getDamOverGeoJsons(" + dateTime + ")");
          // APIからデータ取得
          const { data, error } =
            await TelemeterGeojsonRepository.getDamOverGeoJsons(dateTime);
          Logger.debug(
            "[Telemeter]API - getDamOverGeoJsons(" + dateTime + ") - return"
          );
          Logger.dir(data);
          Logger.dir(error);
          if (!error) {
            tmOverGeoJsonInfo = data;
          }
        }
        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.damExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getDamObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getDamObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getDamObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmOverGeoJsonInfo: tmOverGeoJsonInfo,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setDamGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "dam", status: true });
    }),

    /**
     * 表示範囲のカメラGeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param townLatLngList 市町村座標リスト
     */
    getScamGeoJsons: takeLatest(async function (
      { commit },
      { towns, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug("[Telemeter]act - getScamGeoJsons(towns,townLatLngList)");
      Logger.dir(towns);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "scam", status: false });

      // 観測所GeoJSON取得
      let targetList = [];
      if (prefFlg) {
        // 都道府県単位で取得
        targetList = prefs;
      } else {
        // 市町村単位で取得
        targetList = towns;
      }
      for (let townCnt = 0; townCnt < targetList.length; townCnt++) {
        let target = false;
        if (prefFlg) {
          // 都道府県単位の場合は必ず取得
          target = true;
        } else {
          // 観測所存在フラグが1の市町村のみ取得を行う
          target = townLatLngList.find((townInfo) => {
            return (
              // todo 観測所存在フラグの名前はDBの項目名に合わせる
              townInfo.twnCd == targetList[townCnt].id &&
              townInfo.scamExistFlg == 1
            );
          });
        }

        if (target) {
          // APIからデータ取得
          Logger.debug(
            "[Telemeter]API - getTmScamGeoJsons(" + targetList[townCnt].id + ")"
          );
          const { data: scam, error } =
            await TelemeterGeojsonRepository.getTmScamGeoJsons(
              targetList[townCnt].id
            );
          Logger.debug(
            "[Telemeter]API - getTmScamGeoJsons(" +
              targetList[townCnt].id +
              ") - return"
          );
          Logger.dir(scam);
          Logger.dir(error);
          if (!error) {
            // 地図制御のため、カメラの種別を設定
            scam.features.forEach((feature) => {
              if (feature.properties.sys_id === 1) {
                // 簡易カメラ
                feature.properties.itmknd_cd = 200;
              } else {
                // 河川カメラ
                feature.properties.itmknd_cd = 100;
              }
            });
            // 市町村コードを付与
            if (!prefFlg) {
              scam.twnCd = towns[townCnt].id;
            }
            tmGeoJsonList.push(scam);
          }
        }
      }

      // 取得情報をストアに格納
      commit("setScamGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "scam", status: true });
    }),

    /**
     * 表示範囲の雨量GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getRnGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getRnGeoJsons(towns,getTimeList,townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "rn", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.rnExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getRnObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getRnObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getRnObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setRnGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "rn", status: true });
    }),

    /**
     * 表示範囲の水質GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getQwtrGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getQwtrGeoJsons(towns,getTimeList,townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "qwtr", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.qwtrExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getQwtrObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getQwtrObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getQwtrObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setQwtrGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "qwtr", status: true });
    }),

    /**
     * 表示範囲の海岸GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getCoastGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getCoastGeoJsons(towns,getTimeList,townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "coast", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.coastExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getCoastObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getCoastObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getCoastObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setCoastGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "coast", status: true });
    }),

    /**
     * 表示範囲の積雪GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getSnwGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getSnwGeoJsons(towns,getTimeList,townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "snw", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.snwExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getSnwObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getSnwObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getSnwObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setSnwGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "snw", status: true });
    }),

    /**
     * 表示範囲の危機管理型水位GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param getTimeList 取得時間リスト
     * @param getOverFlg 基準値超過GeoJson取得フラグ
     * @param townLatLngList 市町村座標リスト
     * @param prefFlg 都道府県GeoJSON取得フラグ
     * @param prefs 都道府県リスト
     */
    getSwstgGeoJsons: takeLatest(async function (
      { commit },
      { towns, getTimeList, getOverFlg, townLatLngList, prefFlg, prefs }
    ) {
      Logger.debug(
        "[Telemeter]act - getSwstgGeoJsons(towns,getTimeList," +
          getOverFlg +
          ",townLatLngList," +
          prefFlg +
          ",prefs)"
      );
      Logger.dir(towns);
      Logger.dir(getTimeList);
      Logger.dir(townLatLngList);
      Logger.dir(prefs);

      let tmGeoJsonList = [];

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "swstg", status: false });

      // 観測所GeoJsonを地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        let tmOverGeoJsonInfo = null;
        let tmGeoJsonInfo = [];
        let dateTime = getTimeList[numCnt];

        // 基準値超過GeoJSON取得
        if (getOverFlg) {
          Logger.debug(
            "[Telemeter]API - getSwstgOverGeoJsons(" + dateTime + ")"
          );
          // APIからデータ取得
          const { data, error } =
            await TelemeterGeojsonRepository.getSwstgOverGeoJsons(dateTime);
          Logger.debug(
            "[Telemeter]API - getSwstgOverGeoJsons(" + dateTime + ") - return"
          );
          Logger.dir(data);
          Logger.dir(error);
          if (!error) {
            data.features.forEach((feature) => {
              // 地図制御のため、危機管理型水位の観測所種別を設定
              feature.properties.itmknd_cd = 300;
            });
            tmOverGeoJsonInfo = data;
          }
        }
        // 観測所GeoJSON取得
        let targetList = [];
        if (prefFlg) {
          // 都道府県単位で取得
          targetList = prefs;
        } else {
          // 市町村単位で取得
          targetList = towns;
        }
        for (let tCnt = 0; tCnt < targetList.length; tCnt++) {
          let target = false;
          if (prefFlg) {
            // 都道府県単位の場合は必ず取得
            target = true;
          } else {
            // 観測所存在フラグが1の市町村のみ取得を行う
            target = townLatLngList.find(
              (townInfo) =>
                townInfo.twnCd == targetList[tCnt].id &&
                townInfo.swExistFlg == 1
            );
          }

          if (target) {
            // APIからデータ取得
            Logger.debug(
              "[Telemeter]API - getSwstgObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ")"
            );
            const { data: obs, error } =
              await TelemeterGeojsonRepository.getSwstgObsGeoJsons(
                dateTime,
                targetList[tCnt].id
              );
            Logger.debug(
              "[Telemeter]API - getSwstgObsGeoJsons(" +
                dateTime +
                "," +
                targetList[tCnt].id +
                ") - return"
            );
            Logger.dir(obs);
            Logger.dir(error);
            if (!error) {
              obs.features.forEach((feature) => {
                // 地図制御のため、危機管理型水位の観測所種別を設定
                feature.properties.itmknd_cd = 300;
              });
              if (!prefFlg) {
                // 市町村コードを付与
                obs.twnCd = targetList[tCnt].id;
              }
              tmGeoJsonInfo.push(obs);
            }
          }
        }

        tmGeoJsonList.push({
          date: dateTime,
          tmOverGeoJsonInfo: tmOverGeoJsonInfo,
          tmGeoJsonInfo: tmGeoJsonInfo,
        });
      }

      // 取得情報をストアに格納
      commit("setSwstgGeoJsons", tmGeoJsonList);

      // GeoJSON取得状態を更新
      commit("setGeoJsonGetStatus", { knd: "swstg", status: true });
    }),

    /**
     * 表示範囲の基準観測所GeoJson取得
     * @param {*} param0
     * @param baseTime 基準時間
     * @param rwType 河川予警報タイプ
     * @param rwCd 河川予警報区間コード
     */
    getBaseobsGeoJsons: takeLatest(async function (
      { commit },
      { baseTime, rwType, rwCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getBaseobsGeoJsons(" +
          baseTime +
          "," +
          rwType +
          "," +
          rwCd +
          ")"
      );

      let baseobsGeoJson = null;

      // 洪水予報の場合
      if (rwType == 10) {
        // APIからデータ取得
        Logger.debug(
          "[Telemeter]API - getFldfrBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ")"
        );
        const { data, error } =
          await TelemeterGeojsonRepository.getFldfrBaseobsGeoJsons(
            baseTime,
            rwCd
          );
        Logger.debug(
          "[Telemeter]API - getFldfrBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ") - return"
        );
        Logger.dir(data);
        Logger.dir(error);
        if (!error) {
          baseobsGeoJson = data;
        }
      }
      // 水位周知河川情報の場合
      else if (rwType == 11) {
        // APIからデータ取得
        Logger.debug(
          "[Telemeter]API - getEvstgBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ")"
        );
        const { data, error } =
          await TelemeterGeojsonRepository.getEvstgBaseobsGeoJsons(
            baseTime,
            rwCd
          );
        Logger.debug(
          "[Telemeter]API - getEvstgBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ") - return"
        );
        Logger.dir(data);
        Logger.dir(error);
        if (!error) {
          baseobsGeoJson = data;
        }
      }
      // 水防警報の場合
      else if (rwType == 20) {
        // APIからデータ取得
        Logger.debug(
          "[Telemeter]API - getFldctlBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ")"
        );
        const { data, error } =
          await TelemeterGeojsonRepository.getFldctlBaseobsGeoJsons(
            baseTime,
            rwCd
          );
        Logger.debug(
          "[Telemeter]API - getFldctlBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ") - return"
        );
        Logger.dir(data);
        Logger.dir(error);
        if (!error) {
          baseobsGeoJson = data;
        }
      }
      // ダム放流通知の場合
      else if (rwType == 30) {
        // APIからデータ取得
        Logger.debug(
          "[Telemeter]API - getDamdschBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ")"
        );
        const { data, error } =
          await TelemeterGeojsonRepository.getDamdschBaseobsGeoJsons(
            baseTime,
            rwCd
          );
        Logger.debug(
          "[Telemeter]API - getDamdschBaseobsGeoJsons(" +
            baseTime +
            "," +
            rwCd +
            ") - return"
        );
        Logger.dir(data);
        Logger.dir(error);
        if (!error) {
          baseobsGeoJson = data;
        }
      }

      // 取得情報をストアに格納
      commit("setBaseobsGeoJsons", baseobsGeoJson);
    }),

    /**
     * 横断設定情報取得
     * @param {*} param0
     * @param {*} param1
     */
    async getSurfaceData(
      { state, commit },
      { distanceP, point1Info, point2Info, point3Info, point4Info, point5Info }
    ) {
      Logger.debug("[Telemeter]act - getSurfaceData()");
      Logger.debug("[Telemeter]act - getSurfaceData() distanceP");
      Logger.dir(distanceP);
      Logger.debug("[Telemeter]act - getSurfaceData() point1Info");
      Logger.dir(point1Info);
      Logger.debug("[Telemeter]act - getSurfaceData() point2Info");
      Logger.dir(point2Info);
      Logger.debug("[Telemeter]act - getSurfaceData() point3Info");
      Logger.dir(point3Info);
      Logger.debug("[Telemeter]act - getSurfaceData() point4Info");
      Logger.dir(point4Info);
      Logger.debug("[Telemeter]act - getSurfaceData() point5Info");
      Logger.dir(point5Info);

      const data = state.selectedTm.xsec;
      Logger.debug("[Telemeter]act - getSurfaceData() state.selectedTm.xsec");
      Logger.dir(data);
      var stgobs = data.stgobs;
      var crs = data.crs;

      let conf = {
        dispAB: false,
        locationA: [],
        locationB: [],
        dispP: false,
        locationP: [],
      };

      // 横断データの有無
      var isCross = false;
      // 左右岸緯度経度の有無
      var isBnk = false;

      // 描画なし以外の場合
      if (stgobs.drawType != 0) {
        // 横断マスタ、横断断面マスタがある場合
        if (
          crs != null &&
          crs.sfLeftLimit != null &&
          crs.sfRightLimit != null
        ) {
          Logger.debug(
            "[Telemeter]act - getSurfaceData() 横断マスタ、横断断面マスタがある isCross = true"
          );
          isCross = true;
        }

        // 左右岸緯度経度が全て揃っている場合
        if (
          stgobs.leftBnkHghtLat &&
          stgobs.leftBnkHghtLat != null &&
          stgobs.leftBnkHghtLon &&
          stgobs.leftBnkHghtLon != null &&
          stgobs.rightBnkHghtLat &&
          stgobs.rightBnkHghtLat != null &&
          stgobs.rightBnkHghtLon &&
          stgobs.rightBnkHghtLon != null
        ) {
          Logger.debug(
            "[Telemeter]act - getSurfaceData() 左右岸緯度経度が全て揃っている isBnk = true"
          );
          isBnk = true;
        }

        if (!isCross && !isBnk) {
          // 横断データ・左右岸緯度経度がない場合は描画なしとする
          Logger.debug(
            "[Telemeter]act - getSurfaceData() 横断データ・左右岸緯度経度がない場合は描画なし stgobs.drawType = 0"
          );
          stgobs.drawType = 0;
        } else if (!isBnk) {
          Logger.debug(
            "[Telemeter]act - getSurfaceData() 横断データありで、左右岸緯度経度がない場合は特殊横断を描画 stgobs.drawType = 2"
          );
          // 横断データありで、左右岸緯度経度がない場合は特殊横断を描画
          stgobs.drawType = 2;
        }
      }

      // 横断描画なし、特殊横断の場合はストアに格納して終了
      if (stgobs.drawType == 0 || stgobs.drawType == 2) {
        Logger.debug(
          "[Telemeter]act - getSurfaceData() 横断描画なし、特殊横断の場合はストアに格納して終了"
        );
        // 横断表示設定をストアに格納
        commit("setSurfaceConf", conf);
        // 横断データをストアに格納
        commit("setSurface", data);
        return;
      }

      // 川幅を設定
      stgobs.rvrwid = geodesic.getDistance(
        [stgobs.leftBnkHghtLat, stgobs.leftBnkHghtLon],
        [stgobs.rightBnkHghtLat, stgobs.rightBnkHghtLon]
      );
      Logger.debug(
        "[Telemeter]act - getSurfaceData() 川幅を設定 stgobs.rvrwid = " +
          stgobs.rvrwid
      );

      // 横断データがない場合は水防団待機水位・氾濫注意水位の低い方を観測開始水位(扱い)とする
      if (!crs || !crs.riverBed) {
        var minStg = null;
        if (stgobs.rsrvStg < stgobs.warnStg) {
          minStg = stgobs.rsrvStg;
        } else {
          minStg = stgobs.warnStg;
        }
        if (minStg) {
          stgobs.strtStage = minStg;
        }
        Logger.debug(
          "[Telemeter]act - getSurfaceData() 横断データがない場合は水防団待機水位・氾濫注意水位の低い方を観測開始水位(扱い) stgobs.strtStage = " +
            stgobs.strtStage
        );
      }

      if (stgobs.drawType === 1) {
        Logger.debug(
          "[Telemeter]act - getSurfaceData() 通常横断を描画時の情報取得"
        );
        // A点B点座標を取得
        let endPoint = geodesic.getTmEndPoint(
          [stgobs.leftBnkHghtLat, stgobs.leftBnkHghtLon],
          [stgobs.rightBnkHghtLat, stgobs.rightBnkHghtLon],
          stgobs.rvrInWid,
          state.crossConfig.riverSideMinWidth
        );
        conf.dispAB = true;
        conf.locationA = endPoint.locationA;
        conf.locationB = endPoint.locationB;

        Logger.debug("[Telemeter]act - getSurfaceData() A点座標");
        Logger.dir(conf.locationA);
        Logger.debug("[Telemeter]act - getSurfaceData() B点座標");
        Logger.dir(conf.locationB);

        var result = {
          distance: 0,
          dispP: 0,
          locationP: [],
        };

        // 地点情報を配列化
        var points = [point1Info, point2Info, point3Info, point4Info, point5Info];

        // AB点と地点1～5の最短距離を算出
        for (var idx = 0; idx < points.length; idx++) {
          if (points[idx] && points[idx].center) {
            // A点～地点間の距離を算出
            var disAP = geodesic.getDistance(
              points[idx].center,
              conf.locationA
            );
            if (
              disAP < distanceP &&
              (result.distance === 0 || disAP < result.distance)
            ) {
              result.distance = disAP;
              result.dispP = 1;
              result.locationP = points[idx].center;
            }
            // B点～地点間の距離を算出
            var disBP = geodesic.getDistance(
              points[idx].center,
              conf.locationB
            );

            if (
              disBP < distanceP &&
              (result.distance === 0 || disBP < result.distance)
            ) {
              result.distance = disBP;
              result.dispP = 2;
              result.locationP = points[idx].center;
            }
          }
        }
        Logger.debug(
          "[Telemeter]act - getSurfaceData() 閾値範囲内にあるAB点との最短登録地点の情報"
        );
        Logger.dir(result);

        if (result.distance > 0) {
          var locA = [conf.locationA[1], conf.locationA[0]];
          var locB = [conf.locationB[1], conf.locationB[0]];
          var locP = [result.locationP[1], result.locationP[0]];

          // 登録地点がAB間の内側にあるかをチェック
          let isPresentIn = geodesic.checkPresent(locA, locB, locP);
          // 内側にある場合はAB点からの線を描画しない
          if (!isPresentIn) {
            Logger.debug(
              "[Telemeter]act - getSurfaceData() 登録地点がAB間の内側にある場合 result.dispP = 3"
            );
            result.dispP = 3;
          }

          // 登録地点の表示内容を設定
          conf.dispP = result.dispP;
          conf.locationP = result.locationP;

          Logger.debug(
            "[Telemeter]act - getSurfaceData() 登録地点の表示内容を設定"
          );
          Logger.dir(conf);
        }

        // 横断表示設定をストアに格納
        commit("setSurfaceConf", conf);
        // 横断データをストアに格納
        commit("setSurface", data);
      }
    },
    /**
     * [高アクセス対応]観測値一覧を取得
     * @param ofcCd 管理事務所番号
     * @param itmkndCd 観測所種別コード
     * @param obsCd 観測所コード
     * @param cctvCd 河川カメラID
     * @param scamId 簡易カメラID
     * @param appTime 対象日時
     * @param appTimeRound 観測日時(ファイル取得用)
     * @param sysCamId システムカメラID
     */
    getSelectedTm: takeLatest(async function (
      { commit, state },
      {
        ofcCd,
        itmkndCd,
        obsCd,
        cctvCd,
        scamId,
        appTime,
        appTimeRound,
        sysCamId,
      }
    ) {
      let targetTmData = null;
      let target10mHrData = null;
      let targetTime = null;
      let latestObsTime = null;
      let missingTime = null;
      let round10Time = null;
      // 検索対象時刻
      targetTime = Util.formatDate(appTimeRound);
      // 欠測判定用時刻（欠測判定用に10分単位で末尾を丸める）
      round10Time = Util.formatDate(appTime);
      round10Time =
        Util.formatDate(round10Time).substring(0, round10Time.length - 1) + "0";

      // 最新値ファイル用欠測判定時刻を取得
      if (state.missingTime) {
        missingTime = Util.formatDate(
          Util.subMinutes(round10Time, state.missingTime)
        );
      }

      // 伝送記号
      let obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);

      let payload = {
        itmkndCd: itmkndCd,
        obsFcd: obsFcd,
        cctvCd: cctvCd,
        ofcCd: ofcCd,
        scamId: scamId,
        appTime: targetTime,
        sysCamId: sysCamId,
      };

      // 観測所データ取得
      const { data: obsData } = await TelemeterJsonRepository.getSelectedObs(
        payload
      );

      // アクセスログ出力用パラメータ格納
      commit("setPageLogParam", { payload: payload, obsData: obsData });

      // 河川カメラ、簡易カメラでは無い場合
      if (
        Number(payload.itmkndCd) !== 100 &&
        Number(payload.itmkndCd) !== 200
      ) {
        // 欠測判定時間tmData範囲中の観測値情報を取得
        const { data: tmData } = await TelemeterJsonRepository.getSelectedTm(
          payload
        );
        if (tmData) {
          // グラフデータは欠測判定しない
          target10mHrData = {
            min10Values: tmData.min10Values,
            hrValues: tmData.hrValues,
            predstgValues:
              "predstgValues" in tmData ? tmData.predstgValues : null,
          };
          if (process.env.NODE_ENV === "development") {
            //  ローカルで動作させる場合は欠測判定をしない。
            if (tmData.obsValue != null) {
              // 最新観測値が空の場合は取得しない
              targetTmData = tmData.obsValue;
              // 最新観測値取得時刻
              latestObsTime = tmData.obsValue.obsTime;
              // 開発環境用にグラフ時刻を上書きして値を表示させる
              round10Time = tmData.obsValue.obsTime;
            }
          } else {
            if (
              tmData.obsValue != null &&
              tmData.obsValue.obsTime > missingTime
            ) {
              // 取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
              targetTmData = tmData.obsValue;
              // 最新観測値取得時刻
              latestObsTime = tmData.obsValue.obsTime;
            }
          }
        }
      }

      let result = {};
      if (payload.itmkndCd == 1) {
        // 観測所種別コード=1(雨量)
        let convResult = tmObs.convertSelectedObsRain(
          // 雨量観測所情報
          obsData.obsInfo,
          // 最新雨量観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]10分単位の雨量観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位の雨量観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsRain(convResult.tmObsResult);
      } else if (payload.itmkndCd == 2) {
        // 観測所種別コード = 2(流域平均雨量)
        let convResult = tmObs.convertSelectedObsBsn(
          // 流域平均観測所情報
          obsData.obsInfo,
          // 最新流域平均観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]10分単位の流域平均観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位の流域平均観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsBsn(convResult.tmObsResult);
      } else if (payload.itmkndCd == 3) {
        // 観測所種別コード = 3(積雪)
        let convResult = tmObs.convertSelectedObsSnow(
          // 積雪観測所情報
          obsData.obsInfo,
          // 最新積雪観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]時間単位の積雪観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsSnow(
          convResult.tmObsResult,
          state.graphConfig
        );
      } else if (payload.itmkndCd == 4) {
        // 観測所種別コード = 4(水位)
        let upStgObsData = null;
        let targetUpStgTmData = null;
        let dwStgObsData = null;
        let targetDwStgTmData = null;
        let reprnObsData = null;
        let targetReprnTmData = null;
        let targetReprn10mHrTmData = null;

        // 上流水位観測所がある場合取得
        if (
          obsData &&
          obsData.obsInfo.upObsFcd !== null &&
          obsData.obsInfo.upObsFcd !== "0000000000000"
        ) {
          let payload = {
            itmkndCd: 4,
            obsFcd: obsData.obsInfo.upObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            appTime: targetTime,
          };
          const { data: upStgObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          upStgObsData = upStgObsDataRt;
          const { data: upStgTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);

          if (process.env.NODE_ENV === "development") {
            //  ローカルで動作させる場合は欠測判定をしない。
            if (upStgTmDataRt && upStgTmDataRt.obsValue != null) {
              // 最新観測値が空の場合は取得しない
              targetUpStgTmData = upStgTmDataRt.obsValue;
            }
          } else {
            if (
              upStgTmDataRt &&
              upStgTmDataRt.obsValue != null &&
              upStgTmDataRt.obsValue.obsTime > missingTime
            ) {
              // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
              targetUpStgTmData = upStgTmDataRt.obsValue;
            }
          }
        }

        // 下流水位観測所がある場合取得
        if (
          obsData &&
          obsData.obsInfo.dwObsFcd !== null &&
          obsData.obsInfo.dwObsFcd !== "0000000000000"
        ) {
          let payload = {
            itmkndCd: 4,
            obsFcd: obsData.obsInfo.dwObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            appTime: targetTime,
          };
          const { data: dwStgObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          dwStgObsData = dwStgObsDataRt;
          const { data: dwStgTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);

          if (process.env.NODE_ENV === "development") {
            //  ローカルで動作させる場合は欠測判定をしない。
            if (dwStgTmDataRt && dwStgTmDataRt.obsValue != null) {
              // 最新観測値が空の場合は取得しない
              targetDwStgTmData = dwStgTmDataRt.obsValue;
            }
          } else {
            if (
              dwStgTmDataRt &&
              dwStgTmDataRt.obsValue != null &&
              dwStgTmDataRt.obsValue.obsTime > missingTime
            ) {
              // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
              targetDwStgTmData = dwStgTmDataRt.obsValue;
            }
          }
        }

        // 関連雨量観測所がある場合取得
        if (
          obsData &&
          obsData.obsInfo.reprnObsFcd !== null &&
          obsData.obsInfo.reprnObsFcd !== "0000000000000" &&
          obsData.obsInfo.reprnItmkndCd === 1
        ) {
          let payload = {
            itmkndCd: obsData.obsInfo.reprnItmkndCd,
            obsFcd: obsData.obsInfo.reprnObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            appTime: targetTime,
          };
          const { data: reprnObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          reprnObsData = reprnObsDataRt;
          const { data: reprnTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);
          if (reprnTmDataRt) {
            targetReprn10mHrTmData = {
              min10Values: reprnTmDataRt.min10Values,
              hrValues: reprnTmDataRt.hrValues,
            };

            if (process.env.NODE_ENV === "development") {
              //  ローカルで動作させる場合は欠測判定をしない。
              if (reprnTmDataRt.obsValue != null) {
                // 最新観測値が空の場合は取得しない
                targetReprnTmData = reprnTmDataRt.obsValue;
              }
            } else {
              if (
                reprnTmDataRt.obsValue != null &&
                reprnTmDataRt.obsValue.obsTime > missingTime
              ) {
                // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
                targetReprnTmData = reprnTmDataRt.obsValue;
              }
            }
          }
        }

        let convResult = tmObs.convertSelectedObsStage(
          // 水位観測所情報(観測所情報・横断情報・横断断面情報)
          obsData,
          // 最新水位観測値情報
          targetTmData != null ? targetTmData : null,
          // 上流水位観測所情報
          upStgObsData != null ? upStgObsData.obsInfo : null,
          // 最新上流水位観測値情報
          targetUpStgTmData != null ? targetUpStgTmData : null,
          // 下流水位観測所情報
          dwStgObsData != null ? dwStgObsData.obsInfo : null,
          // 最新下流水位観測値情報
          targetDwStgTmData != null ? targetDwStgTmData : null,
          // 関連雨量観測所情報
          reprnObsData != null ? reprnObsData.obsInfo : null,
          // 最新関連雨量観測値情報
          targetReprnTmData != null ? targetReprnTmData : null,
          // [グラフ用]10分単位の水位観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位の水位観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // [グラフ用]予測水位リスト
          target10mHrData != null
            ? tmObs.getTargetPredStgData(
                target10mHrData,
                obsData,
                targetTime,
                "graph"
              )
            : null,
          // [グラフ用]10分単位の関連雨量観測値情報
          targetReprn10mHrTmData != null
            ? targetReprn10mHrTmData.min10Values
            : null,
          // [グラフ用]時間単位の関連雨量観測値情報
          targetReprn10mHrTmData != null
            ? targetReprn10mHrTmData.hrValues
            : null,
          // [横断用]予測水位リスト
          target10mHrData != null
            ? tmObs.getTargetPredStgData(
                target10mHrData,
                obsData,
                targetTime,
                "cross"
              )
            : null,
          // [横断用]最新観測時刻
          latestObsTime != null ? Util.formatDate(latestObsTime) : null,
          // 10分単位の画面表示時刻取得
          round10Time,
          // 画面表示時刻
          Util.formatDate(appTime),
          // 予測水位「現況」の時刻
          target10mHrData != null
            ? tmObs.getCrntPredTime(target10mHrData, obsData, targetTime)
            : null
        );

        result = tmObs.convertObsStage(
          convResult.tmObsResult,
          state.messageConfig.stg
        );
      } else if (payload.itmkndCd == 6) {
        // 観測所種別コード = 6(水質)
        let convResult = tmObs.convertSelectedObsWtrQual(
          // 水質観測所情報
          obsData.obsInfo,
          // 最新水質観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]時間単位の水質観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsWtrQual(convResult.tmObsResult);
      } else if (payload.itmkndCd == 7) {
        // 観測所種別コード = 7(ダム諸量)
        let dwStgObsData = null;
        let targetDwStgTmData = null;
        let targetDwStg10mHrTmData = null;
        let relatTmObsData = null;
        let targetRelatTmTmData = null;
        let targetRelatTm10mHrTmData = null;
        let relatRdObsData = null;
        let targetrelatRdTmData = null;
        let targetrelatRd10mHrTmData = null;

        // 下流水位観測所がある場合取得
        if (
          obsData &&
          obsData.obsInfo.dwStgObsFcd !== null &&
          obsData.obsInfo.dwStgObsFcd !== "0000000000000"
        ) {
          let payload = {
            itmkndCd: 4,
            obsFcd: obsData.obsInfo.dwStgObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            // ダム観測所の観測値を取得した時刻
            appTime: targetTime,
          };

          const { data: dwStgObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          dwStgObsData = dwStgObsDataRt;
          const { data: dwStgTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);

          if (dwStgTmDataRt) {
            targetDwStg10mHrTmData = {
              min10Values: dwStgTmDataRt.min10Values,
              hrValues: dwStgTmDataRt.hrValues,
            };
            if (process.env.NODE_ENV === "development") {
              //  ローカルで動作させる場合は欠測判定をしない。
              if (dwStgTmDataRt.obsValue != null) {
                // 最新観測値が空の場合は取得しない
                targetDwStgTmData = dwStgTmDataRt.obsValue;
              }
            } else {
              if (
                dwStgTmDataRt.obsValue != null &&
                dwStgTmDataRt.obsValue.obsTime > missingTime
              ) {
                // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
                targetDwStgTmData = dwStgTmDataRt.obsValue;
              }
            }
          }
        }

        // 関連雨量取得
        // 流域平均雨量、レーダ流域平均雨量が存在する場合は流域平均雨量を優先して取得する
        if (
          obsData.obsInfo.relatTmObsFcd !== null &&
          obsData.obsInfo.relatTmObsFcd !== "0000000000000"
        ) {
          let payload = {
            itmkndCd: obsData.obsInfo.relatTmItmKndCd,
            obsFcd: obsData.obsInfo.relatTmObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            // ダム観測所の観測値を取得した時刻
            appTime: targetTime,
          };
          const { data: relatTmObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          relatTmObsData = relatTmObsDataRt;
          const { data: relatTmTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);

          if (relatTmTmDataRt) {
            targetRelatTm10mHrTmData = {
              min10Values: tmObs.convertRelatDataList(
                relatTmTmDataRt.min10Values,
                obsData.obsInfo.relatTmItmKndCd,
                2
              ),
              hrValues: tmObs.convertRelatDataList(
                relatTmTmDataRt.hrValues,
                obsData.obsInfo.relatTmItmKndCd,
                2
              ),
            };
            if (process.env.NODE_ENV === "development") {
              //  ローカルで動作させる場合は欠測判定をしない。
              if (relatTmTmDataRt.obsValue != null) {
                // 最新観測値が空の場合は取得しない
                targetRelatTmTmData = tmObs.convertRelatObsValue(
                  relatTmTmDataRt.obsValue,
                  obsData.obsInfo.relatTmItmKndCd,
                  2
                );
              }
            } else {
              if (
                relatTmTmDataRt.obsValue != null &&
                relatTmTmDataRt.obsValue.obsTime > missingTime
              ) {
                // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
                targetRelatTmTmData = tmObs.convertRelatObsValue(
                  relatTmTmDataRt.obsValue,
                  obsData.obsInfo.relatTmItmKndCd,
                  2
                );
              }
            }
          }
        } else if (
          obsData.obsInfo.relatRdObsFcd !== null &&
          obsData.obsInfo.relatRdObsFcd !== "0000000000000"
        ) {
          let payload = {
            itmkndCd: obsData.obsInfo.relatRdItmKndCd,
            obsFcd: obsData.obsInfo.relatRdObsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
            // ダム観測所の観測値を取得した時刻
            appTime: targetTime,
          };
          const { data: relatRdObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          relatRdObsData = relatRdObsDataRt;
          const { data: relatRdTmDataRt } =
            await TelemeterJsonRepository.getSelectedTm(payload);

          if (relatRdTmDataRt) {
            targetrelatRd10mHrTmData = {
              min10Values: tmObs.convertRelatDataList(
                relatRdTmDataRt.min10Values,
                obsData.obsInfo.relatRdItmKndCd,
                20
              ),
              hrValues: tmObs.convertRelatDataList(
                relatRdTmDataRt.hrValues,
                obsData.obsInfo.relatRdItmKndCd,
                20
              ),
            };
            if (process.env.NODE_ENV === "development") {
              //  ローカルで動作させる場合は欠測判定をしない。
              if (relatRdTmDataRt.obsValue != null) {
                // 最新観測値が空の場合は取得しない
                targetrelatRdTmData = tmObs.convertRelatObsValue(
                  relatRdTmDataRt.obsValue,
                  obsData.obsInfo.relatRdItmKndCd,
                  20
                );
              }
            } else {
              if (
                relatRdTmDataRt.obsValue != null &&
                relatRdTmDataRt.obsValue.obsTime > missingTime
              ) {
                // 最新観測値が空ではなく、取得した最新観測値情報の時刻が欠測判定以内の場合値を取得する。
                targetrelatRdTmData = tmObs.convertRelatObsValue(
                  relatRdTmDataRt.obsValue,
                  obsData.obsInfo.relatRdItmKndCd,
                  20
                );
              }
            }
          }
        }

        let convResult = tmObs.convertSelectedObsDam(
          // ダム観測所情報
          obsData.obsInfo,
          // 最新ダム観測値情報
          targetTmData != null ? targetTmData : null,
          // 下流水位観測所情報
          dwStgObsData != null ? dwStgObsData.obsInfo : null,
          // 最新下流水位観測値情報
          targetDwStgTmData != null ? targetDwStgTmData : null,
          // 流域平均雨量観測所情報
          relatTmObsData != null ? relatTmObsData.obsInfo : null,
          // 流域平均雨量観測所情報
          targetRelatTmTmData != null ? targetRelatTmTmData : null,
          // レーダ流域平均雨量観測所情報
          relatRdObsData != null ? relatRdObsData.obsInfo : null,
          // レーダ流域平均雨量観測値情報
          targetrelatRdTmData != null ? targetrelatRdTmData : null,
          // [グラフ用]10分単位のダム観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位のダム観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // [グラフ用]10分単位の流域平均雨量観測値情報
          targetRelatTm10mHrTmData != null
            ? targetRelatTm10mHrTmData.min10Values
            : null,
          // [グラフ用]時間単位の流域平均雨量観測値情報
          targetRelatTm10mHrTmData != null
            ? targetRelatTm10mHrTmData.hrValues
            : null,
          // [グラフ用]10分単位のレーダ流域平均雨量観測値情報
          targetrelatRd10mHrTmData != null
            ? targetrelatRd10mHrTmData.min10Values
            : null,
          // [グラフ用]時間単位のレーダ流域平均雨量観測値情報
          targetrelatRd10mHrTmData != null
            ? targetrelatRd10mHrTmData.hrValues
            : null,
          // [模式図用]時間単位の下流水位観測値情報
          targetDwStg10mHrTmData != null
            ? targetDwStg10mHrTmData.hrValues
            : null,
          // 10分単位の最新時刻取得
          round10Time,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsDam(
          convResult.tmObsResult,
          state.messageConfig.stg
        );
      } else if (payload.itmkndCd == 12) {
        // 観測所種別コード = 12(海岸)
        let convResult = tmObs.convertSelectedObsCoast(
          // 海岸観測所情報
          obsData.obsInfo,
          // 最新海岸観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]10分単位の海岸観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位の海岸観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsCoast(convResult.tmObsResult);
      } else if (payload.itmkndCd == 20 || payload.itmkndCd == 21) {
        // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
        let convResult = tmObs.convertSelectedObsRdBsn(
          // レーダ流域平均観測所情報
          obsData.obsInfo,
          // 最新レーダ流域平均観測値情報
          targetTmData != null ? targetTmData : null,
          // [グラフ用]10分単位のレーダ流域平均観測値情報
          target10mHrData != null ? target10mHrData.min10Values : null,
          // [グラフ用]時間単位のレーダ流域平均観測値情報
          target10mHrData != null ? target10mHrData.hrValues : null,
          // 画面表示時刻
          Util.formatDate(appTime)
        );

        result = tmObs.convertObsRdBsn(convResult.tmObsResult);
      } else if (payload.itmkndCd == 100) {
        // 観測所種別コード = 100(河川カメラ)
        let relatStgObsData = null;
        let relatSwStgObsData = null;

        // 関連水位観測所がある場合取得
        if (obsData && obsData.obsInfo.obsFcd !== null) {
          let payload = {
            itmkndCd: 4,
            obsFcd: obsData.obsInfo.obsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
          };
          const { data: relatStgObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          // 関連水位観測所のマスタ情報を取得
          relatStgObsData = relatStgObsDataRt;
        }

        // 関連危機管理水位観測所がある場合取得
        if (obsData && obsData.obsInfo.swobsCd !== null) {
          let payload = {
            swobsCd: obsData.obsInfo.swobsCd,
          };
          const { data: relatSwStgObsDataRt } =
            await SwinJsonRepository.getSelectedMtSwobs(payload);
          // 関連危機管理水位観測所のマスタ情報を取得
          relatSwStgObsData = relatSwStgObsDataRt;
        }

        let convResult = tmObs.convertSelectedObsCctv(
          // 河川カメラID
          payload.cctvCd,
          // 河川カメラ情報
          obsData.obsInfo,
          // 関連水位観測所情報
          relatStgObsData != null ? relatStgObsData.obsInfo : null,
          // 関連危機管理水位観測所情報
          relatSwStgObsData != null ? relatSwStgObsData : null
        );

        result = tmObs.convertObsCctv(convResult.tmObsResult);
      } else if (payload.itmkndCd == 200) {
        //観測所種別コード = 200(簡易カメラ)
        let relatStgObsData = null;
        let relatSwStgObsData = null;
        const { data: scamNowDetailInfo } =
          await TelemeterJsonRepository.getScamDetailJson(
            obsData.obsInfo.currDateProvUrl
          );

        // 関連水位観測所がある場合取得
        if (obsData && obsData.obsInfo.obsFcd !== null) {
          let payload = {
            itmkndCd: 4,
            obsFcd: obsData.obsInfo.obsFcd,
            cctvCd: null,
            ofcCd: null,
            scamId: null,
          };
          const { data: relatStgObsDataRt } =
            await TelemeterJsonRepository.getSelectedObs(payload);
          // 関連水位観測所のマスタ情報を取得
          relatStgObsData = relatStgObsDataRt;
        }

        // 関連危機管理水位観測所がある場合取得
        if (obsData && obsData.obsInfo.swobsCd !== null) {
          let payload = {
            swobsCd: obsData.obsInfo.swobsCd,
          };
          const { data: relatSwStgObsDataRt } =
            await SwinJsonRepository.getSelectedMtSwobs(payload);
          // 関連危機管理水位観測所のマスタ情報を取得
          relatSwStgObsData = relatSwStgObsDataRt;
        }

        let convResult = tmObs.convertSelectedObsScam(
          // 簡易カメラID
          payload.scamId,
          // 簡易カメラ情報
          obsData.obsInfo,
          // 関連水位観測所情報
          relatStgObsData != null ? relatStgObsData.obsInfo : null,
          // 関連危機管理水位観測所情報
          relatSwStgObsData != null ? relatSwStgObsData : null,
          scamNowDetailInfo != null ? scamNowDetailInfo : null
        );

        result = tmObs.convertObsScam(convResult.tmObsResult);
      }

      // 取得情報をストアに格納
      commit("setSelectedTm", result);
    }),
    /**
     * [高アクセス対応]雨量観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmRainPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmRainPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );

      // 伝送記号
      let obsFcd = null;
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }

      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmRainPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            hour: past.rnHr,
            hourCcd: past.rnHrCcd,
            total: past.rnInc,
            totalCcd: past.rnIncCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]流域平均雨量観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmBsnPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmBsnPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );
      let obsFcd = null;
      if (ofcCd == undefined) {
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }

      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmBsnPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            hour: past.bsnrnHr,
            hourCcd: past.bsnrnHrCcd,
            total: past.bsnrnInc,
            totalCcd: past.bsnrnIncCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]積雪深観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmSnowPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmSnowPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );

      let obsFcd = null;
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }
      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmSnowPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            snow: past.snwdp,
            snowCcd: past.snwdpCcd,
            temp: past.tmp,
            tempCcd: past.tmpCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]通常水位観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmStagePast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmStagePast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );
      let obsFcd = null;
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }
      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmStagePast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            stage: past.stg,
            stageHght: past.stgHght,
            stageCcd: past.stgCcd,
            stageOvlvl: past.stgOvlvl,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]水質観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmWtrQualPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmWtrQualPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );

      let obsFcd = null;
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }

      // データ取得
      const { data } =
        await TelemeterObsJsonRepository.getSelectedTmWtrQualPast(obsFcd, date);

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            temp: past.wtrtmp,
            tempCcd: past.wtrtmpCcd,
            tempOvcd: past.wtrtmpOvcd,
            ph: past.ph,
            phCcd: past.phCcd,
            phOvcd: past.phOvcd,
            dox: past.dox,
            doxCcd: past.doxCcd,
            doxOvcd: past.doxOvcd,
            cond: past.conduct,
            condCcd: past.conductCcd,
            condOvcd: past.conductOvcd,
            turb: past.turbdty,
            turbCcd: past.turbdtyCcd,
            turbOvcd: past.turbdtyOvcd,
            cod: past.cod,
            codCcd: past.codCcd,
            codOvcd: past.codOvcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]ダム諸量観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmDamPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmDamPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );

      let obsFcd = null;
      if (ofcCd == undefined) {
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }
      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmDamPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            level: past.storLvl,
            levelCcd: past.storLvlCcd,
            sink: past.allSink,
            sinkCcd: past.allSinkCcd,
            disch: past.allDisch,
            dischCcd: past.allDischCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]海岸観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmCoastPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmCoastPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );
      let obsFcd = null;
      // 伝送記号
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }
      // APIからデータ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmCoastPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            onthwvHght: past.onthwvHght,
            onthwvHghtCcd: past.onthwvHghtCcd,
            tidlvlCautOvflg: past.tidlvlCautOvflg,
            tidlvlWarnOvflg: past.tidlvlWarnOvflg,
            onthwvCycl: past.onthwvCycl,
            onthwvCyclCcd: past.onthwvCyclCcd,
            onthwvHghtCautOvflg: past.onthwvHghtCautOvflg,
            onthwvHghtWarnOvflg: past.onthwvHghtWarnOvflg,
            tide: past.tidlvl,
            tideCcd: past.tidlvlCcd,
            windSpd: past.avewndSpd,
            windSpdCcd: past.avewndSpdCcd,
            avewndSpdCautOvflg: past.avewndSpdCautOvflg,
            avewndSpdWarnOvflg: past.avewndSpdWarnOvflg,
            windDir: past.avewndDir,
            windDirCcd: past.avewndDirCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * [高アクセス対応]レーダ流域平均雨量観測値過去一覧を取得
     * @param date 取得開始日
     * @param ofcCd 管理事務所番号(未設定の場合：選択中テレメータ情報パラメータから取得)
     * @param itmkndCd 観測所種別コード(同上)
     * @param obsCd 観測所コード(同上)
     */
    async getSelectedTmRdBsnPast(
      { state, commit },
      { date, ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[Telemeter]act - getSelectedTmRdBsnPast(" +
          date +
          ofcCd +
          itmkndCd +
          obsCd +
          ")"
      );

      let obsFcd = null;
      if (ofcCd == undefined) {
        // 過去一週間から実行する場合
        // 伝送記号
        obsFcd =
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5);
      } else {
        // 印刷から実行する場合
        obsFcd =
          ("0000" + ofcCd).slice(-5) +
          ("00" + itmkndCd).slice(-3) +
          ("0000" + obsCd).slice(-5);
      }

      // データ取得
      const { data } = await TelemeterObsJsonRepository.getSelectedTmRdBsnPast(
        obsFcd,
        date
      );

      let sortList = null;
      let pastList = [];
      if (data) {
        sortList = data.pastValues;
        // 時刻、日付で昇順に並び替え
        sortList.sort(function (a, b) {
          if (a.time < b.time) return -1;
          if (a.time > b.time) return 1;
          if (a.date < b.date) return -1;
          if (a.date > b.date) return 1;
          return 0;
        });
        // プロパティ名変換
        for (var past of sortList) {
          var item = {
            date: past.date,
            time: past.time,
            hour: past.rdbsnrnHr,
            hourCcd: past.rdbsnrnHrCcd,
            total: past.rdbsnrnInc,
            totalCcd: past.rdbsnrnIncCcd,
          };
          pastList.push(item);
        }
      }

      let result = {};
      if (null != data && Object.keys(pastList).length > 0) {
        for (let idx in pastList) {
          const past = pastList[idx];
          let key = past.date + past.time;
          if (past.time == "00:00") {
            let time = "24:00";
            let date = Util.formatDate(
              Util.subDays(past.date, 1),
              "YYYY/MM/DD"
            );
            key = date + time;
          }
          result[key] = past;
        }
      }

      // 取得情報をストアに格納
      commit("setSelectedTmPast", result);
    },
    /**
     * 地点登録の観測所一覧の対象日時情報を取得(登録地点情報高アクセス対応)
     * @param appTime 対象日時
     * @param tmObj 地点登録の観測所一覧
     */
    getTmPointIndivData: takeLatest(async function (
      { state, commit },
      { appTime, appTimeRound, tmObj }
    ) {
      Logger.debug(
        "[Telemeter]act - getTmPointIndivData(" +
          appTime +
          "," +
          appTimeRound +
          "," +
          tmObj +
          ")"
      );
      // 格納リスト
      let resultList = [];
      let obsDataList = [];
      // 欠測判定時刻
      let missingTime = null;
      let round10Time = null;
      // 欠測判定用時刻（欠測判定用に10分単位で末尾を丸める）
      round10Time = Util.formatDate(appTime);
      round10Time =
        Util.formatDate(round10Time).substring(0, round10Time.length - 1) + "0";
      // 最新値ファイル用欠測判定時刻を取得
      if (state.missingTime) {
        missingTime = Util.formatDate(
          Util.subMinutes(round10Time, state.missingTime)
        );
      }

      // 観測所一覧(危機管理水位観測所以外)
      if (tmObj.tmPoint.length != 0) {
        let obsFcdParamList = tmList.setTmPointIndivParam(tmObj.tmPoint);
        for (var obsFcdParam of obsFcdParamList) {
          const { data: obsInfo } =
            await TelemeterJsonRepository.getTmPointIndivInfoData(obsFcdParam);
          var obsData = null;
          if (obsInfo != null) {
            var obsValue = null;
            if (global.KWB_MODE == "reduction") {
              if (
                obsFcdParam.obsKnd == "stg" ||
                obsFcdParam.obsKnd == "dam" ||
                obsFcdParam.obsKnd == "rn"
              ) {
                const { data: tmpObsValueReduction } =
                  await TelemeterJsonRepository.getTmPointIndivValueData(
                    obsFcdParam,
                    appTimeRound
                  );
                obsValue = tmpObsValueReduction;
              }
            } else {
              const { data: tmpObsValueNotReduction } =
                await TelemeterJsonRepository.getTmPointIndivValueData(
                  obsFcdParam,
                  appTimeRound
                );
              obsValue = tmpObsValueNotReduction;
            }
            if (process.env.NODE_ENV === "development") {
              if (obsValue) {
                obsData = tmList.setTmPointIndivData(
                  obsInfo.obsInfo,
                  obsValue.obsValue
                );
              } else {
                obsData = tmList.setTmPointIndivData(
                  obsInfo.obsInfo,
                  null,
                  Util.formatDate(appTimeRound)
                );
              }
            } else {
              if (
                obsValue != null &&
                obsValue.obsValue != null &&
                obsValue.obsValue.obsTime > missingTime
              ) {
                obsData = tmList.setTmPointIndivData(
                  obsInfo.obsInfo,
                  obsValue.obsValue
                );
              } else {
                obsData = tmList.setTmPointIndivData(
                  obsInfo.obsInfo,
                  null,
                  Util.formatDate(appTimeRound)
                );
              }
            }
          }
          if (obsData != null) {
            obsDataList.push(obsData);
          }
        }
      }

      // 危機管理水位観測所一覧
      if (tmObj.swPoint.length != 0) {
        let swobsParamList = tmList.setTmSwPointIndivParam(tmObj.swPoint);
        for (var swobsParam of swobsParamList) {
          const { data: swobsInfo } =
            await TelemeterJsonRepository.getTmPointIndivInfoData(swobsParam);
          var swobsData = null;
          if (swobsInfo != null) {
            const { data: swobsValue } =
              await TelemeterJsonRepository.getTmPointIndivValueData(
                swobsParam,
                appTimeRound
              );
            if (swobsValue != null && swobsValue.obsValue != null) {
              swobsData = tmList.setSwTmPointIndivData(
                swobsInfo.obsInfo,
                swobsValue.obsValue
              );
            } else {
              swobsData = tmList.setSwTmPointIndivData(
                swobsInfo.obsInfo,
                null,
                Util.formatDate(appTimeRound)
              );
            }
          }
          if (swobsData != null) {
            obsDataList.push(swobsData);
          }
        }
      }

      // [登録地点観測所一覧]観測所種別リストを作成
      let tmPointIndivDataResult = tmList.convertIndivDataList(obsDataList);

      // [登録地点観測所一覧]表示データ作成
      let convResult = tmList.convertRpTmList(
        tmPointIndivDataResult,
        state.messageConfig.stg,
        state.messageConfig.obsList
      );

      // アイテム種別毎に格納
      resultList = {
        nmStg: convResult.Stg.nmList,
        nmDam: convResult.Dam.nmList,
        nmRain: convResult.Rain.nmList,
        nmSnow: convResult.Snow.nmList,
        nmTmQwtr: convResult.Qwtr.nmList,
        nmCoast: convResult.Coast.nmList,
        nmSwstg: convResult.Swstg.nmList,
      };

      // 取得時間をストアに格納
      commit("setTmPointIndivDatasParam", appTime);
      // 取得情報をストアに格納
      commit("setTmPointIndivDatas", resultList);
    }),
    /**
     * [高アクセス対応]都道府県市町村情報を取得
     * @param prefs 都道府県市町村一覧
     * @param towns 市町村リスト
     * @param selectObsDisp 観測所表示設定
     * @param apiFlg API実行フラグ
     * @param fullOpenFlg 全開閉フラグ
     * @param appTime 表示時刻
     * @param appTimeRound 観測日時(ファイル取得用)
     * @param townsAcqTime 市町村リスト取得日時
     * @param prefTownType 都道府県 市町村種別
     * @param dispPrefList 表示している都道府県市町村リスト
     */
    getPrefInfo: takeLatest(async function (
      { commit, state },
      {
        prefs,
        towns,
        selectObsDisp,
        apiFlg,
        fullOpenFlg,
        appTime,
        appTimeRound,
        townsAcqTime,
        prefTownType,
        dispPrefList,
      }
    ) {
      Logger.debug(
        "[Telemeter]act - getPrefInfo(" +
          prefs +
          towns +
          selectObsDisp +
          apiFlg +
          fullOpenFlg +
          appTime +
          appTimeRound +
          townsAcqTime +
          prefTownType +
          dispPrefList +
          ")"
      );
      var prefList = [];
      var result = [];
      if (apiFlg) {
        // 都道府県検索条件フラグ
        var isPref = false;
        var keyList = [];

        // 都道府県 市町村種別毎に検索条件を変更
        if (prefTownType == "town") {
          isPref = false;
          keyList = towns;
        } else {
          isPref = true;
          keyList = prefs;
        }

        if (keyList.length > 0) {
          var tmpList = [];

          // 都道府県別市町村リスト取得
          for (var pref of prefs) {
            const { data } = await TelemeterObsJsonRepository.getPrefTwnInfo(
              pref.id
            );
            if (data) {
              data.prefCd = pref.id;
              tmpList.push(data);
            }
          }

          // 市町村レベルの場合は表示範囲に合致する市町村のみを取得する
          if (!isPref) {
            prefList = tmList.getDispTowns(towns, tmpList);
          } else {
            prefList = tmpList;
          }

          // 都道府県別超過情報リスト取得
          for (var prefOvIdx of prefList) {
            const { data } = await TelemeterObsJsonRepository.getPrefOverInfo(
              prefOvIdx.prefCd,
              appTimeRound
            );
            // 都道府県別超過情報追加
            if (data) {
              prefOvIdx.stgOvlvl = data.stgOvlvl;
              prefOvIdx.swStgOvlvl = data.swStgOvlvl;
              // 市町村別超過情報リスト生成
              for (var twnOvIdx of prefOvIdx.twnInfo) {
                for (var dataIdx of data.twnInfo) {
                  if (twnOvIdx.twnCd == dataIdx.twnCd) {
                    twnOvIdx.stgOvlvl = dataIdx.stgOvlvl;
                    twnOvIdx.swStgOvlvl = dataIdx.swStgOvlvl;
                    break;
                  }
                }
              }
            }
          }
        }
        // 全開閉する場合
        if (fullOpenFlg) {
          var tmInfo = null;
          var targetTmInfo = null;
          var allResult = [];

          for (var prefAllIdx of prefList) {
            for (var twnAllIdx of prefAllIdx.twnInfo) {
              tmInfo = null;
              targetTmInfo = null;
              allResult = [];

              // 都道府県市町村別観測所情報取得
              const { data: ObsInfo } =
                await TelemeterObsJsonRepository.getObsDatasByTown(
                  twnAllIdx.twnCd
                );
              Logger.debug(
                "[tmlist]act - getObsDatasByTown(" + twnAllIdx.twnCd + ")"
              );

              // 都道府県市町村別テレメータ情報取得
              const { data: TmInfo } =
                await TelemeterObsJsonRepository.getTmDatasByTown(
                  twnAllIdx.twnCd,
                  appTimeRound
                );
              Logger.debug(
                "[tmlist]act - getTmDatasByTown(" +
                  twnAllIdx.twnCd +
                  appTimeRound +
                  ")"
              );
              if (TmInfo) {
                targetTmInfo = TmInfo.tmList;
              }

              // 観測所と観測値情報をマッチさせる
              tmInfo = tmList.matchObsTmInfo(
                ObsInfo.obsList,
                targetTmInfo,
                appTime,
                state.missingTime
              );

              let convObsInfo = tmList.convertTmInfo(
                tmInfo,
                state.messageConfig.stg,
                state.messageConfig.obsList
              );
              allResult = tmList.setDispTwnTmInfo(twnAllIdx.twnCd, convObsInfo);

              twnAllIdx.tmDetailInfo = allResult;
            }
          }

          // 市町村別観測所一覧全開閉完了フラグ
          commit("setTmListTwnFullOpenEndFlg", true);
          // 市町村別観測所一覧全開閉準備フラグ
          commit("setTmListTwnFullOpenReadyFlg", false);
        }

        // 表示都道府県市町村情報を格納
        commit("setDispPrefTmList", prefList);
        if (prefList) {
          result = tmList.createDataPrefInfo(
            JSON.parse(JSON.stringify(prefList)),
            selectObsDisp,
            isPref
          );
        }
      } else {
        // API再取得しない場合、表示対象の市町村を抽出する
        result = tmList.createDataPrefInfo(
          JSON.parse(JSON.stringify(dispPrefList)),
          selectObsDisp,
          isPref
        );
      }

      commit("setPrefTmList", result);
      // パラメータをストアに格納
      commit("setTmDatasParam", {
        appTime: appTimeRound,
        townsAcqTime: townsAcqTime,
      });
    }),
    /**
     * [高アクセス対応]水系河川情報を取得
     * @param prefs 表示都道府県
     * @param towns 表示市町村
     * @param selectObsDisp 観測所表示設定
     * @param apiFlg API実行フラグ
     * @param fullOpenFlg 全開閉フラグ
     * @param appTime 表示時刻
     * @param appTimeRound 観測日時(ファイル取得用)
     * @param townsAcqTime 市町村リスト取得日時
     * @param prefTownType 都道府県 市町村種別
     * @param dispRsysList 表示している水系河川観測所一覧
     */
    getRsysInfo: takeLatest(async function (
      { commit, state },
      {
        prefs,
        towns,
        selectObsDisp,
        apiFlg,
        fullOpenFlg,
        appTime,
        appTimeRound,
        townsAcqTime,
        prefTownType,
        dispRsysList,
      }
    ) {
      Logger.debug(
        "[Telemeter]act - getRsysInfo(" +
          prefs +
          towns +
          selectObsDisp +
          apiFlg +
          fullOpenFlg +
          dispRsysList +
          appTime +
          appTimeRound +
          townsAcqTime +
          prefTownType +
          ")"
      );
      var rsysList = [];
      var result = [];
      // 水系一時格納リスト
      var sortRsysList = [];

      if (apiFlg) {
        // 都道府県検索条件フラグ
        var isPref = false;
        var keyList = [];

        // 都道府県 市町村種別毎に検索条件を変更
        if (prefTownType == "town") {
          isPref = false;
          keyList = towns;
        } else {
          isPref = true;
          keyList = prefs;
        }

        if (keyList.length > 0) {
          // 都道府県別水系リスト取得
          for (var key of keyList) {
            const { data } = await TelemeterObsJsonRepository.getRsysInfo(
              key.id,
              isPref
            );
            if (data) {
              rsysList.push(data);
            }
          }

          // 水系追加フラグ
          var addFlg = false;
          for (var rsysTmpIdx of rsysList) {
            for (var rvrTmpInfoIdx of rsysTmpIdx.rsysInfo) {
              addFlg = true;
              for (var tmpIdx of sortRsysList) {
                // 同水系がすでにある場合は追加しない
                if (tmpIdx.rsysCd === rvrTmpInfoIdx.rsysCd) {
                  addFlg = false;
                }
              }
              if (addFlg) {
                sortRsysList.push(rvrTmpInfoIdx);
              }
            }
          }
          // 水系番号順に並び替え
          sortRsysList.sort(function (a, b) {
            if (a.rsysCd < b.rsysCd) return -1;
            if (a.rsysCd > b.rsysCd) return 1;
            return 0;
          });

          // 水系別河川リスト取得
          for (var rvrInfoIdx of sortRsysList) {
            const { data } = await TelemeterObsJsonRepository.getRvrInfo(
              rvrInfoIdx.rsysCd
            );
            if (data) {
              rvrInfoIdx.rvrInfo = data.rvrInfo;
              rvrInfoIdx.rsysNm = data.rsysNm;
            }
          }

          // 水系別超過情報リスト取得
          for (var rsysOvInfoIdx of sortRsysList) {
            const { data } = await TelemeterObsJsonRepository.getRsysOverInfo(
              rsysOvInfoIdx.rsysCd,
              appTimeRound
            );
            // 水系河川超過情報を追加
            if (data) {
              rsysOvInfoIdx.stgOvlvl = data.stgOvlvl;
              rsysOvInfoIdx.swStgOvlvl = data.swStgOvlvl;
              // 河川超過情報リスト取得
              for (var rvrOvRvrIdx of rsysOvInfoIdx.rvrInfo) {
                for (var dataIdx of data.rvrInfo) {
                  if (rvrOvRvrIdx.rvrCd == dataIdx.rvrCd) {
                    rvrOvRvrIdx.stgOvlvl = dataIdx.stgOvlvl;
                    rvrOvRvrIdx.swStgOvlvl = dataIdx.swStgOvlvl;
                    break;
                  }
                }
              }
            }
          }
        }

        if (fullOpenFlg) {
          var tmInfo = null;
          var targetTmInfo = null;
          var allResult = [];

          for (var rsysAllRsysIdx of sortRsysList) {
            // 水系河川別テレメータ情報取得
            const { data: TmInfo } =
              await TelemeterObsJsonRepository.getTmDatasByRsys(
                rsysAllRsysIdx.rsysCd,
                appTimeRound
              );
            Logger.debug(
              "[tmlist]act - getTmDatasByRsys(" + rsysAllRsysIdx.rsysCd + ")"
            );
            for (var rsysAllRvrIdx of rsysAllRsysIdx.rvrInfo) {
              targetTmInfo = null;
              allResult = [];
              // 河川別観測所情報取得
              const { data: ObsInfo } =
                await TelemeterObsJsonRepository.getObsDatasByRvr(
                  rsysAllRvrIdx.rvrCd
                );
              Logger.debug(
                "[tmlist]act - getObsDatasByRvr(" + rsysAllRvrIdx.rvrCd + ")"
              );

              if (TmInfo) {
                for (var dataAllIdx of TmInfo.rvrInfo) {
                  if (rsysAllRvrIdx.rvrCd == dataAllIdx.rvrCd) {
                    targetTmInfo = dataAllIdx.tmList;
                    break;
                  }
                }
              }
              // 観測所と観測値情報をマッチさせる
              tmInfo = tmList.matchObsTmInfo(
                ObsInfo.obsList,
                targetTmInfo,
                appTime,
                state.missingTime
              );

              var convObsInfo = tmList.convertTmInfo(
                tmInfo,
                state.messageConfig.stg,
                state.messageConfig.obsList
              );
              allResult = tmList.setDispRvrTmInfo(
                rsysAllRvrIdx.rvrCd,
                convObsInfo
              );
              rsysAllRvrIdx.tmDetailInfo = allResult;
            }
          }
          // 水系別観測所一覧全開閉完了フラグ
          commit("setTmListRsysFullOpenEndFlg", true);
          // 水系別観測所一覧全開閉準備フラグ
          commit("setTmListRsysFullOpenReadyFlg", false);
        }
        // 表示水系河川情報を格納
        commit("setDispRsysTmList", sortRsysList);
        if (rsysList) {
          result = tmList.createDataRsysInfo(
            JSON.parse(JSON.stringify(sortRsysList)),
            selectObsDisp,
            isPref
          );
        }
      } else {
        // 水系河川情報を成形
        result = tmList.createDataRsysInfo(
          JSON.parse(JSON.stringify(dispRsysList)),
          selectObsDisp,
          isPref
        );
      }
      // 取得情報をストアに格納
      commit("setRsysTmList", result);
      // 表示時刻、取得時刻をストアに格納
      commit("setTmDatasParam", {
        appTime: appTimeRound,
        rsysAcqTime: townsAcqTime,
      });
    }),
    /**
     * [高アクセス対応]都道府県市町村別観測所情報
     * @param twnCd 市町村コード
     * @param appTime 表示時刻
     * @param appTimeRound 観測日時(ファイル取得用)
     */
    getTmDatasByTown: takeLatest(async function (
      { commit, state },
      { twnCd, appTime, appTimeRound }
    ) {
      var tmInfo = null;
      var targetTmInfo = null;
      var result = [];

      //  都道府県市町村別観測所情報取得
      const { data: ObsInfo } =
        await TelemeterObsJsonRepository.getObsDatasByTown(twnCd);
      Logger.debug("[tmlist]act - getObsDatasByTown(" + twnCd + ")");

      // 都道府県市町村別テレメータ情報取得
      const { data: TmInfo } =
        await TelemeterObsJsonRepository.getTmDatasByTown(twnCd, appTimeRound);
      Logger.debug(
        "[tmlist]act - getTmDatasByTown(" + twnCd + appTimeRound + ")"
      );
      if (TmInfo) {
        targetTmInfo = TmInfo.tmList;
      }
      // 観測所と観測値情報をマッチさせる
      tmInfo = tmList.matchObsTmInfo(
        ObsInfo.obsList,
        targetTmInfo,
        appTime,
        state.missingTime
      );

      var convObsInfo = tmList.convertTmInfo(
        tmInfo,
        state.messageConfig.stg,
        state.messageConfig.obsList
      );
      result = tmList.setDispTwnTmInfo(twnCd, convObsInfo);

      // 取得情報をストアに格納
      commit("updatePrefTmList", result);
    }),
    /**
     * [高アクセス対応]水系河川情報を取得
     * @param rsysCd 水系番号
     * @param rvrCd 河川番号
     * @param appTime 表示時刻
     * @param appTimeRound 観測日時(ファイル取得用)
     */
    getTmDatasByRsys: takeLatest(async function (
      { commit, state },
      { rsysCd, rvrCd, appTime, appTimeRound }
    ) {
      var tmInfo = null;
      var targetTmInfo = null;
      var result = [];

      //  河川別観測所情報取得
      const { data: ObsInfo } =
        await TelemeterObsJsonRepository.getObsDatasByRvr(rvrCd);
      Logger.debug("[tmlist]act - getObsDatasByRvr(" + rvrCd + ")");

      // 水系河川別テレメータ情報取得
      const { data: TmInfo } =
        await TelemeterObsJsonRepository.getTmDatasByRsys(rsysCd, appTimeRound);
      Logger.debug("[tmlist]act - getTmDatasByRsys(" + rsysCd + ")");

      if (TmInfo) {
        for (var datIdx of TmInfo.rvrInfo) {
          if (rvrCd == datIdx.rvrCd) {
            // 水系レベルから対象の河川テレメータ情報を取得する。
            targetTmInfo = datIdx.tmList;
            break;
          }
        }
      }
      // 観測所と観測値情報をマッチさせる
      tmInfo = tmList.matchObsTmInfo(
        ObsInfo.obsList,
        targetTmInfo,
        appTime,
        state.missingTime
      );

      var convObsInfo = tmList.convertTmInfo(
        tmInfo,
        state.messageConfig.stg,
        state.messageConfig.obsList
      );
      result = tmList.setDispRvrTmInfo(rvrCd, convObsInfo);

      // 取得情報をストアに格納
      commit("updateRsysTmList", result);
    }),
    /**
     * 表示範囲の基準値超過テレメータ件数を取得し、基準値超過テレメータ存在フラグを更新する
     * @param towns 市町村リスト
     * @param prefs 都道府県リスト
     * @param prefTownType 都道府県 市町村種別
     * @param fldCtlParty 水防団モード
     * @param getTime 取得時間
     */
    updateTmOverExistenceFlg: takeLatest(async function (
      { commit },
      { towns, prefs, prefTownType, fldCtlParty, getTime }
    ) {
      Logger.debug(
        "[Telemeter]act - updateTmOverExistenceFlg(towns,prefs," +
          prefTownType +
          "," +
          fldCtlParty +
          "," +
          getTime +
          ")"
      );
      Logger.dir(towns);
      Logger.dir(prefs);

      let flgStatus = false;
      let tmStgFlg = false;
      let tmRnFlg = false;
      let swStgFlg = false;
      // APIからデータ取得
      if (prefTownType == "pref") {
        // 都道府県の場合
        for (let prefsCount = 0; prefsCount < prefs.length; prefsCount++) {
          Logger.debug(
            "[Telemeter]API - getTmOvPref(" +
              prefs[prefsCount].id +
              "," +
              getTime +
              ")"
          );
          Logger.dir(prefs[prefsCount].id);

          const { data, error } = await TelemeterJsonRepository.getTmOvPref(
            prefs[prefsCount].id,
            getTime
          );
          Logger.debug(
            "[Telemeter]API - getTmOvPref(" +
              prefs[prefsCount].id +
              "," +
              getTime +
              ") - return"
          );
          Logger.dir(data);
          Logger.dir(error);
          if (!error) {
            // 水位
            if (data.tmOverListResult.tmStg) {
              // 一般モードの場合は水防団待機水位超過を含めない
              if (fldCtlParty && data.tmOverListResult.tmStg.length > 0) {
                tmStgFlg = true;
              } else if (
                !fldCtlParty &&
                data.tmOverListResult.tmStg.find((item) => item.stgOvlvl > 10)
              ) {
                tmStgFlg = true;
              }
            }
            // 雨量
            if (
              data.tmOverListResult.tmRn &&
              data.tmOverListResult.tmRn.length > 0
            ) {
              tmRnFlg = true;
            }
            // 危機管理型水位
            if (
              data.tmOverListResult.swStg &&
              data.tmOverListResult.swStg.find((item) => item.swstgOvlvl > 30) // 観測開始水位は含めない
            ) {
              swStgFlg = true;
            }
          }
        }
      } else {
        // 市町村の場合
        for (let townsCount = 0; townsCount < towns.length; townsCount++) {
          Logger.debug(
            "[Telemeter]API - getTmOvTwn(" +
              towns[townsCount].id +
              "," +
              getTime +
              ")"
          );
          Logger.dir(towns[townsCount]);
          const { data, error } = await TelemeterJsonRepository.getTmOvTwn(
            towns[townsCount].id,
            getTime
          );
          Logger.debug(
            "[Telemeter]API - getTmOvTwn(" +
              towns[townsCount].id +
              "," +
              getTime +
              ") - return"
          );
          Logger.dir(data);
          Logger.dir(error);
          if (!error) {
            // 水位
            if (data.tmOverListResult.tmStg) {
              // 一般モードの場合は水防団待機水位超過を含めない
              if (fldCtlParty && data.tmOverListResult.tmStg.length > 0) {
                tmStgFlg = true;
              } else if (
                !fldCtlParty &&
                data.tmOverListResult.tmStg.find((item) => item.stgOvlvl > 10)
              ) {
                tmStgFlg = true;
              }
            }
            // 雨量
            if (
              data.tmOverListResult.tmRn &&
              data.tmOverListResult.tmRn.length > 0
            ) {
              tmRnFlg = true;
            }
            // 危機管理型水位
            if (
              data.tmOverListResult.swStg &&
              data.tmOverListResult.swStg.find((item) => item.swstgOvlvl > 30) // 観測開始水位は含めない
            ) {
              swStgFlg = true;
            }
          }
        }
      }
      if (tmStgFlg || tmRnFlg || swStgFlg) {
        flgStatus = true;
      }
      let typeFlg = { tmStgFlg, tmRnFlg, swStgFlg };
      commit("setTmOverExistenceFlg", flgStatus);
      commit("setTmOverTypeFlg", typeFlg);
    }),
    /**
     * 最新値ファイル用欠測判定時間取得
     */
    getMissingTime: takeLatest(async function ({ commit }) {
      Logger.debug("[Telemeter]act - getMissingTime()");
      // APIからデータ取得
      const { data, error } = await SystemJsonRepository.getEdtCmn();
      Logger.debug("[Telemeter]API - getEdtCmn() - return");
      Logger.dir(data);
      Logger.dir(error);
      if (!error) {
        commit("setMissingTime", data.missingTime);
      }
    }),
  /**
   * 過去画像URLの作成と取得
   * @param appTime 観測日時
   * @param cameraId 画像名取得
   * @param itmkndCd 観測所種別コード
   * @param sysId カメラ種別
   * @param camSlidData 設定ファイル(取得時間範囲,取得最大コマ数,取得最小コマ数)
   */
    obsAppTimeArray: takeLatest(async function(
      { state, commit },
      [{ appTime, cameraId, itmkndCd, sysId }, camSlidData, originProduction, historyCamUrl, testEnvironmentsIp]
    ) {
      if (!appTime || !cameraId || !itmkndCd) {
        commit("setHistoryPlayStatus", stateNone);
        if (state.viewMode === 'normal' ) {
          commit("setHistoryPlayStatus", stateNone);
        } else {          
          commit("setEnlargeHistoryPlayStatus", stateNone);
        }
        commit("setArrayHistoryImages", []);
        return;
      }
      const minutesStep = sysId === 1 ? 5 : 10;
      let startTime;
      startTime = tmObs.roundTimeToInterval(appTime, sysId);
      const endTime = new Date(startTime.getTime() - camSlidData.acquisitionTimeRange * 60000);
      let getHistoryImages = [];
      let getHistoryAppTime = [];

      /** 取得可能範囲内かつ、格納された値が最大コマ数より少ない場合は繰り返し処理 */
      while (getHistoryImages.length < camSlidData.maxNumberFrames && startTime >= endTime) {
        let afterformatAppTime = Util.getDateConnectPath(startTime);
        const path = `${afterformatAppTime}/${cameraId}.jpg`;
        let fullPath;
        
        const result = await tmObs.getUrl(path, itmkndCd, originProduction, historyCamUrl, testEnvironmentsIp)
        if (result.status === 200 || result.status === 304) {
          if (location.origin === originProduction) {
            fullPath = historyCamUrl + path;
          } else if(location.origin.includes('localhost') || location.origin.includes(testEnvironmentsIp)) {
            fullPath = location.origin + `/kawabou/file/files/master/obs/cam/history/` + path;
          } else {
            // 試験環境
            fullPath = `http://` + testEnvironmentsIp + `/cam/history/` + path;
          }
          getHistoryImages.unshift(fullPath);
          getHistoryAppTime.unshift(tmObs.convertTimestampToDateString(afterformatAppTime))
        }
        startTime = new Date(startTime.getTime() - minutesStep * 60000);
      }

      /** 最小コマ数以上、画像取得できたらスライダー再生可能 */
      if (getHistoryImages.length >= camSlidData.minNumberFrames) {
        commit("setArrayHistoryAppTime", getHistoryAppTime);
        commit("setSliderLabelTime", await tmObs.setArrayTimeData(getHistoryAppTime, "sliderLabel"))
        if (sysId === 1) {
          const arrayHistoryJson = tmObs.replaceJpgWithJson(getHistoryImages);
          const setDetailTimeArray = await tmObs.setArrayTimeData(arrayHistoryJson, "detailTime");
          commit("setDetailTime", setDetailTimeArray);
        }
        commit("setArrayHistoryImages", getHistoryImages);
        return;
      } else {
        if (state.viewMode === 'normal') {
          commit("setHistoryPlayStatus", stateNone);
        } else {          
          commit("setEnlargeHistoryPlayStatus", stateNone);
        }
        commit("setArrayHistoryImages", getHistoryImages);
        commit("setSliderMissingImages", true);
      }
    })
  }),
  getters: {
    /** 選択中テレメータの伝送記号取得 */
    getSelectedTmObsFcd(state) {
      if (null != state.selectedTmParam) {
        return (
          ("0000" + state.selectedTmParam.ofcCd).slice(-5) +
          ("00" + state.selectedTmParam.itmkndCd).slice(-3) +
          ("0000" + state.selectedTmParam.obsCd).slice(-5)
        );
      }
      return null;
    },
    arrayHistoryImages: state => state.historyImageSlider.arrayHistoryImages,
    movieCurrentIndex: state => state.historyImageSlider.movieCurrentIndex,
    enlargedMovieCurrentIndex: state => state.historyImageSlider.enlargedMovieCurrentIndex,
    historyPlayStatus: state => state.historyImageSlider.historyPlayStatus,
    enlargeHistoryPlayStatus: state => state.historyImageSlider.enlargeHistoryPlayStatus,
    viewMode: state => state.historyImageSlider.viewMode,
    /** 履歴動画再生中状態 */
    isPlay(state) {
      return state.historyImageSlider.viewMode === 'enlarged' ? state.historyImageSlider.enlargeHistoryPlayStatus === statePlay : state.historyImageSlider.historyPlayStatus === statePlay;
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay(state) {
      return state.historyImageSlider.viewMode === 'enlarged' ? (state.historyImageSlider.enlargeHistoryPlayStatus === stateNone || state.historyImageSlider.enlargeHistoryPlayStatus === stateStop ) : 
      (state.historyImageSlider.historyPlayStatus === stateNone || state.historyImageSlider.historyPlayStatus === stateStop);
    },
    /** 履歴動画準備中状態 */
    isReady(state) {
      return state.historyImageSlider.viewMode === 'enlarged' ? state.historyImageSlider.enlargeHistoryPlayStatus === stateReadyMovie : state.historyImageSlider.historyPlayStatus === stateReadyMovie;
    },
    /** 履歴動画停止状態 */
    isStop(state) {
      return state.historyImageSlider.viewMode === 'enlarged' ? state.historyImageSlider.enlargeHistoryPlayStatus === stateStop : state.historyImageSlider.historyPlayStatus === stateStop;
    },
    /** 履歴動画未再生状態 */
    isNone(state) {
      return state.historyImageSlider.viewMode === 'enlarged' ? state.historyImageSlider.enlargeHistoryPlayStatus === stateNone : state.historyImageSlider.historyPlayStatus === stateNone;
    },
    /** 履歴動画再生中状態 */
    isPlayMb(state) {
      return state.historyImageSlider.isEnlargeView ? state.historyImageSlider.enlargeHistoryPlayStatus === statePlay : state.historyImageSlider.historyPlayStatus === statePlay;
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlayMb(state) {
      return state.historyImageSlider.isEnlargeView ? (state.historyImageSlider.enlargeHistoryPlayStatus === stateNone || state.historyImageSlider.enlargeHistoryPlayStatus === stateStop ) : 
      (state.historyImageSlider.historyPlayStatus === stateNone || state.historyImageSlider.historyPlayStatus === stateStop);
    },
    /** 履歴動画準備中状態 */
    isReadyMb(state) {
      return state.historyImageSlider.isEnlargeView ? state.historyImageSlider.enlargeHistoryPlayStatus === stateReadyMovie : state.historyImageSlider.historyPlayStatus === stateReadyMovie;
    },
    /** 履歴動画停止状態 */
    isStopMb(state) {
      return state.historyImageSlider.isEnlargeView ? state.historyImageSlider.enlargeHistoryPlayStatus === stateStop : state.historyImageSlider.historyPlayStatus === stateStop;
    },
    /** 履歴動画未再生状態 */
    isNoneMb(state) {
      return state.historyImageSlider.isEnlargeView ? state.historyImageSlider.enlargeHistoryPlayStatus === stateNone : state.historyImageSlider.historyPlayStatus === stateNone;
    },
  },
};
